/* ═══════════════════════════════════════════════════════════════════════════
   mat8-fiche.js — LE MOTEUR DES TROIS FICHES. Écrit UNE fois.

   Deux moitiés, et elles ne se parlent presque pas :

     ① LA SCÈNE — reprise de `maquettes/_art/socle.js`. 🛑 LE JS N'ANIME JAMAIS
       UNE PROPRIÉTÉ : il calcule un scalaire, le CSS fait l'image.
         `--calme` sur <html>  : 0 en haut de page, 1 en bas (et `--agite` = 1-calme)
         `--prog`  sur la jauge : la course
         `--p`     sur chaque <section data-scene> : -1 haut, 0 centre, +1 bas
       Une seule boucle rAF, un écouteur passif, TOUS les rects lus avant
       d'en écrire un seul, et la boucle s'arrête 400 ms après le dernier
       mouvement — aucun travail quand la page est immobile.

     ② LE CONFIGURATEUR — il ne DESSINE rien. Les choix sont écrits dans le
       HTML, en vrais contrôles de formulaire.
       🛑 C'EST VOULU : « l'état par défaut est l'état SANS JS, et il est
          complet ; le JS SOUSTRAIT ». Un configurateur qui se génère au
          chargement laisse une page vide quand le script échoue — et rien ne
          le dit à l'écran. Ici le JS chiffre, grise, explique, récapitule.
          Les lignes de récapitulatif sans objet sont RETIRÉES (`hidden`),
          jamais créées.

   🛑 CE QUI A DISPARU DE CE FICHIER, ET POURQUOI. Il écrivait `--onde-a` et
      `--onde-t` à chaque clic de fermeté : l'amplitude et la durée
      d'amortissement d'une onde SVG changeaient en direct sous le chiffre
      monumental. « le truc du F5 qui bouge en temps réel c'est too much ». Sur
      une fiche produit, ce qui bouge pendant qu'on lit détourne de la seule
      chose à faire. Le palier reste DIT — chiffre, couches, retour au calme —
      il ne s'anime plus. Les règles CSS et les deux image-clés sont parties
      avec : une règle orpheline finit par être « réparée ».

   Règles d'interaction, reprises du configurateur qui fonctionne en production :
     · les choix impossibles sont AFFICHÉS, désactivés, AVEC LEUR RAISON en
       toutes lettres — jamais masqués : on apprend la règle au lieu de
       chercher le bouton disparu ;
     · 🛑 RIEN N'EST COCHÉ D'AVANCE, sauf le MODE de cote (tailles standard).
       La stabilisation depuis le 30/09 (« F0 est quand même un choix »), le
       soutien lombaire et le vinyle depuis le 05/10 (« ne coche pas soutien
       lombaire et vinyle d'origine d'avance pour respecter la règle ») :
       « Sans » et « D'origine » sont des réponses comme les autres, chacune
       avec sa consigne, et la commande ne part pas tant qu'elles manquent ;
     · une configuration impossible rend `null`, pas 0 — « un socle qui
       n'existe pas n'a pas de prix, il n'est pas GRATUIT » ;
     · chaque bouton porte son propre écart de prix, en direct.

   🛑 L'ORDRE DES CLÉS. La largeur détermine la BANDE de prix, la fermeté le
      PALIER. Les deux se demandent avant tout ce qu'elles contraignent — le
      soutien lombaire dépend des deux à la fois, il vient donc après les deux.
      Sur le Lyra, une clé de prix demandée APRÈS les dimensions rendait le
      parcours impossible à terminer (mesuré le 07/09). On ne le refait pas.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var doc = document.documentElement;
  doc.className += ' js';
  doc.style.scrollBehavior = 'smooth';

  var sobre = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ═════════════════════════════════════════════════════════════════════════
     ①  LA SCÈNE
     ═════════════════════════════════════════════════════════════════════════ */

  /* `--k` DOIT vivre sur <html> : posé sur la section, il battrait la valeur
     héritée et doublerait l'amplitude de la parallaxe. */
  function majK() { doc.style.setProperty('--k', window.innerWidth < 760 ? '.5' : '1'); }
  majK();
  addEventListener('resize', majK, { passive: true });

  var scenes = [].slice.call(document.querySelectorAll('[data-scene]'));
  var visibles = [];
  if (scenes.length && 'IntersectionObserver' in window) {
    var ioProche = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        var i = visibles.indexOf(e.target);
        if (e.isIntersecting) { if (i < 0) visibles.push(e.target); e.target.classList.add('proche'); }
        else { if (i >= 0) visibles.splice(i, 1); e.target.classList.remove('proche'); }
      });
    }, { rootMargin: '25% 0px 25% 0px' });
    scenes.forEach(function (s) { ioProche.observe(s); });
  }

  var jauge = document.querySelector('.jauge i');
  var chapNom = document.querySelector('[data-chapitre]');
  var chapitres = [];
  /* le nom du chapitre est LU SUR LA PAGE, jamais écrit à la main : une liste
     de liens tenue à part est exactement ce qui donne l'air d'une documentation. */
  [].forEach.call(document.querySelectorAll('h2'), function (t) {
    var sec = t.closest('section');
    if (!sec) return;
    var nom = (t.getAttribute('data-chap') || t.textContent || '').replace(/\s+/g, ' ').trim();
    if (nom) chapitres.push({ sec: sec, t: nom });
  });

  var enCours = false, dernier = 0;
  function boucle() {
    var vh = window.innerHeight, demi = vh / 2, i;

    /* ① LECTURE groupée — aucun style écrit ici, sinon aller-retour de mise
       en page à chaque élément. */
    var n = visibles.length, rects = new Array(n);
    for (i = 0; i < n; i++) rects[i] = visibles[i].getBoundingClientRect();
    var haut = doc.scrollHeight - vh;
    var course = haut > 0 ? Math.min(1, Math.max(0, window.scrollY / haut)) : 0;
    var rc = [];
    for (i = 0; i < chapitres.length; i++) rc.push(chapitres[i].sec.getBoundingClientRect().top);

    /* ② ÉCRITURE groupée. */
    for (i = 0; i < n; i++) {
      var r = rects[i];
      var p = (demi - (r.top + r.height / 2)) / (demi + r.height / 2);
      visibles[i].style.setProperty('--p', (p < -1 ? -1 : p > 1 ? 1 : p).toFixed(4));
    }
    /* 🛑 LA THÈSE : la page se comporte comme la chose qu'elle vend. On entre
       dans une eau agitée, elle s'apaise en descendant, et le geste d'achat se
       fait dans le silence. Toute amplitude du CSS est multipliée par `--agite`. */
    doc.style.setProperty('--calme', course.toFixed(4));
    doc.style.setProperty('--agite', (1 - course).toFixed(4));
    if (jauge) jauge.style.setProperty('--prog', course.toFixed(4));

    if (chapNom && chapitres.length) {
      var k = 0;
      for (i = 0; i < chapitres.length; i++) if (rc[i] <= vh * 0.34) k = i;
      if (chapNom.textContent !== chapitres[k].t) chapNom.textContent = chapitres[k].t;
    }

    if (Date.now() - dernier > 400) { enCours = false; return; }
    requestAnimationFrame(boucle);
  }
  function demande() {
    dernier = Date.now();
    if (enCours) return;
    enCours = true; requestAnimationFrame(boucle);
  }
  addEventListener('scroll', demande, { passive: true });
  addEventListener('resize', demande, { passive: true });
  demande();

  /* L'ENTRÉE — une seule fois, puis on se débranche. */
  if (!sobre && 'IntersectionObserver' in window) {
    var ioVu = new IntersectionObserver(function (ents, o) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('vu'); o.unobserve(e.target);
      });
    }, { threshold: 0.18 });
    [].forEach.call(document.querySelectorAll('.entre,.monte'), function (n) { ioVu.observe(n); });
  } else {
    [].forEach.call(document.querySelectorAll('.entre,.monte'), function (n) { n.classList.add('vu'); });
  }

  /* LES FILMS — jamais de `src` avant le besoin, pause hors écran, et un
     `.catch()` silencieux : un refus d'autoplay n'est pas une erreur. */
  [].forEach.call(document.querySelectorAll('video[data-src]'), function (v) {
    function charge() {
      if (!v.src) v.src = v.getAttribute('data-src');
      var j = v.play(); if (j && j.catch) j.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) charge(); else if (!v.paused) v.pause(); });
      }, { rootMargin: '200px' }).observe(v);
    } else { charge(); }
  });

  /* ═════════════════════════════════════════════════════════════════════════
     ②  LE CONFIGURATEUR
     ═════════════════════════════════════════════════════════════════════════ */
  var brut = document.getElementById('tarif');
  var form = document.querySelector('[data-config]');
  if (!brut || !form) return;

  /* ── LES VARIANTES REELLES, quand la fiche en porte ────────────────────
     🛑 Ce fichier sert DEUX contextes : les pages `/pages/matelas-*`, qui sont
        des maquettes et n'ont pas de variante, et les fiches produit engendrees
        par `porter_mat8_fiche.py`, qui portent `#variantes` et achetent pour de
        bon. La presence du bloc suffit a distinguer les deux : pas de reglage,
        pas de branche a maintenir ailleurs.
     ⚠️ Sans ce bloc, le comportement d'origine est conserve a l'identique —
        le bouton simule et LE DIT, ce qui reste juste sur une maquette. */
  var VAR = [];
  var ACHAT = false;
  try {
    var bv = document.getElementById('variantes');
    if (bv) { VAR = JSON.parse(bv.textContent) || []; }
    ACHAT = !!window.__MAT8_ACHAT && VAR.length > 0;
  } catch (e) { VAR = []; ACHAT = false; }

  var T;
  try { T = JSON.parse(brut.textContent); }
  catch (e) {
    /* 🛑 un tarif illisible doit se VOIR. Une page muette qui affiche des prix
       vides est pire qu'une page qui avoue. */
    form.setAttribute('data-tarif-casse', '1');
    return;
  }

  /* ══ 05/10 · LE LIT, PUIS LES POCHES ═════════════════════════════════════════
     🛑 « sur les fiches produits matelas double faut vraiment insister pour pas
        perdre les gens que c'est la taille du lit qui prenne et qui divise par 2
        sinon créer système de mettre la taille couchage de leur lits double avec
        choix d'une poche ou 2 ». Les fiches duo faisaient choisir « 70, 75, 80 cm »
        sous la légende « Largeur du cadre » : c'étaient des largeurs de POCHE, et
        le client devait diviser son lit par deux lui-même.
     👉 Le mode DUO ne s'active que si le tarif de la section porte la clé `duo`.
        Alors : `largeur` = LARGEUR DU LIT (les bandes du tarif sont écrites en lits),
        la poche vaut la moitié, calculée et jamais saisie ; on choisit « Les deux »
        ou « Une seule » (et laquelle) ; une fermeté PAR poche commandée ; le prix
        est la SOMME des poches, au prix exact des variantes duo de la boutique ; le
        panier reçoit une ligne de la variante duo par poche, avec le côté et la
        taille du lit en propriétés.
     ⚠️ Sans la clé `duo` (fiches simples, pages `litaeau-fiche-*`), RIEN ne change
        ici : toutes les branches nouvelles sont gardées par `DUO`. */
  var DUO = !!T.duo;
  var GAMME = T.gamme || T.nom;

  var EUR = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR',
    minimumFractionDigits: 0, maximumFractionDigits: 0 });
  /* ⚠️ `Intl` fr-FR sépare les milliers par une FINE INSÉCABLE (U+202F). DM Sans
     ne la porte pas : à la capture, « 1 233 € » sortait « 1233 € » — le
     séparateur était bien dans le DOM, il ne se DESSINAIT pas. Vu à l'image,
     jamais à la relecture. On le remplace par l'insécable ordinaire (U+00A0),
     qu'aucune des deux fontes du lot ne manque. */
  function eur(n) { return EUR.format(n)
    .replace(new RegExp('[' + String.fromCharCode(0x202F, 0x2009) + ']', 'g'),
             String.fromCharCode(0xA0)); }
  function cm(n) { return String(n).replace('.', ',') + ' cm'; }
  /* un texte posé en `innerHTML` (le verdict « hors gamme » porte des liens) s'échappe d'abord */
  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* une cote complète : « 80 × 200 cm », espaces insécables autour du signe × */
  function dim(l, L) {
    return L ? String(l).replace('.', ',') + ' × ' + String(L).replace('.', ',') + ' cm'
      : String(l).replace('.', ',') + ' cm';
  }

  /* ── la géométrie du tarif ────────────────────────────────────────────────
     🛑 DEUX ÉCRITURES DE DIMENSIONS, et les confondre INVENTE des cotes.
       · Softside / Softside Q : `90/100/120x200/220` est un CROISEMENT.
       · Hardside : `90x200/90x213/100x200` sont des COUPLES COMPLETS.
     Quand `couples[]` est là, IL FAIT FOI — on ne croise jamais
     `largeurs × longueurs`. La version précédente fabriquait 30 combinaisons
     pour 17 réelles : 100×213, 122×200, 140×213 et 152×200 n'existent nulle
     part au tarif. Cette fonction est le seul endroit où la question se pose. */
  function bandeDe(larg) {
    for (var i = 0; i < T.bandes.length; i++) {
      var b = T.bandes[i];
      if (b.couples && b.couples.length) {
        for (var j = 0; j < b.couples.length; j++) if (b.couples[j][0] === larg) return { b: b, i: i };
      } else if (b.largeurs.indexOf(larg) >= 0) return { b: b, i: i };
    }
    return null;
  }
  function longueursDe(larg) {
    var d = bandeDe(larg);
    if (!d) return [];
    if (d.b.couples && d.b.couples.length) {
      return d.b.couples.filter(function (c) { return c[0] === larg; }).map(function (c) { return c[1]; });
    }
    return d.b.longueurs.slice();
  }

  /* 🛑 TOUTES LES COTES RÉELLEMENT IMPRIMÉES, à plat. C'est la seule liste qui
     a le droit de répondre « cette cote existe » — et c'est elle qui donne les
     bornes de la saisie sur mesure, au lieu d'une constante écrite à la main.
     En DUO, ce sont des cotes de LIT : les bornes du sur-mesure deviennent celles
     du lit (140 ou 150 à 200 × 200 à 240), plus celles d'une poche — l'ancienne
     fiche annonçait 90-200 dans ses champs et bornait à 70-100 dans ce moteur. */
  var COTES = (function () {
    var out = [];
    T.bandes.forEach(function (b, i) {
      if (b.couples && b.couples.length) {
        b.couples.forEach(function (c) { out.push({ l: c[0], L: c[1], i: i }); });
      } else {
        b.largeurs.forEach(function (l) {
          b.longueurs.forEach(function (L) { out.push({ l: l, L: L, i: i }); });
        });
      }
    });
    return out;
  }());
  var BORNES = (function () {
    var b = { lmin: Infinity, lmax: -Infinity, Lmin: Infinity, Lmax: -Infinity };
    COTES.forEach(function (c) {
      if (c.l < b.lmin) b.lmin = c.l;
      if (c.l > b.lmax) b.lmax = c.l;
      if (c.L < b.Lmin) b.Lmin = c.L;
      if (c.L > b.Lmax) b.Lmax = c.L;
    });
    return b;
  }());

  /* 🛑 LA RÈGLE DU SUR-MESURE, MOT POUR MOT (tarif p. 37, 38 et 39, la même
     phrase les trois fois) : « Dimensions spéciales entre deux dimensions
     standard (max 240x240 cm) supplément 180 € AJOUTÉ À LA TAILLE PLUS
     GRANDE ». Une cote intermédiaire n'a donc pas de prix à elle : elle est
     facturée sur la cote standard immédiatement supérieure, plus 180 €.
     Conséquence qu'on n'a pas le droit d'oublier : le soutien lombaire et le
     BIOVYN dépendent de la LARGEUR, donc de la largeur FACTURÉE, pas de celle
     qu'on a tapée. Une seule règle, appliquée partout. */
  function cotePlusGrande(l, L) {
    var best = null;
    COTES.forEach(function (c) {
      if (c.l < l || c.L < L) return;
      if (!best || c.l < best.l || (c.l === best.l && c.L < best.L)) best = c;
    });
    return best;
  }

  function groupeDe(f) {
    for (var i = 0; i < T.paliers.length; i++) if (T.paliers[i].f === f) return T.paliers[i].g;
    return null;
  }
  function palierDe(f) {
    for (var i = 0; i < T.paliers.length; i++) if (T.paliers[i].f === f) return T.paliers[i];
    return null;
  }
  /* 🛑 rend `null`, jamais 0 : une combinaison qui n'existe pas n'a pas de
     prix — elle n'est pas GRATUITE. En DUO, c'est le prix d'UNE poche. */
  function prixBase(larg, f) {
    var d = bandeDe(larg), g = groupeDe(f);
    if (!d || !g) return null;
    var p = d.b.prix[g];
    return (typeof p === 'number') ? p : null;
  }
  /* 🛑 « A PARTIR DE » DOIT ETRE ATTEIGNABLE AVEC CE QUI EST COCHE. */
  function plancherAu(f) {
    var g = groupeDe(f), min = null;
    for (var i = 0; i < T.bandes.length; i++) {
      var p = T.bandes[i].prix[g];
      if (typeof p === 'number' && (min === null || p < min)) min = p;
    }
    return min === null ? T.plancher : min;
  }

  function prixLombaire(larg) {
    var o = T.options.lombaire;
    if (!larg) return null;
    return larg <= o.seuil_petit ? o.petit : o.grand;
  }
  /* le vinyle ne dépend pas du palier : « mode + bande seulement ».
     05/10 (soir) : le seuil s'écrit dans le tarif de la section (`options.biovyn.seuil_petit`,
     « uno 90/100/120 » aux p. 37, 38 et 39) — la première bande n'est PAS le petit format
     partout : en Hardside elle s'arrête à 100, et 122 cm relève du grand dans les deux
     lectures. Sans seuil (pages anciennes), la règle d'avant : première bande = petit. */
  function prixBiovyn(larg) {
    var o = T.options.biovyn;
    if (!o || !larg) return null;
    if (typeof o.seuil_petit === 'number') return larg <= o.seuil_petit ? o.petit : o.grand;
    var d = bandeDe(larg);
    if (!d) return null;
    return d.i === 0 ? o.petit : o.grand;
  }
  /* DUO : « dual / kombi dual → 125 » — UN prix pour le lit, quand on remplace les deux
     poches. Pour UNE poche d'un lit duo, le tarif ne dit rien : `null`, jamais un prix
     deviné (BIOVYN n'est alors pas proposé). */
  function prixBiovynDuo() {
    var o = T.options.biovyn;
    if (!o) return null;
    return typeof o.dual === 'number' ? o.dual : (typeof o.grand === 'number' ? o.grand : null);
  }
  function lombairePossible(f) {
    return T.options.lombaire.paliers.indexOf(f) >= 0;
  }

  /* ── 05/10 · LES QUESTIONS OBLIGATOIRES ───────────────────────────────────
     🛑 « oui ne coche pas soutien lombaire et vinyle d'origine d'avance pour
        respecter la règle ». Un groupe rendu SANS `checked` dans la section est
        une question : il porte sa consigne, il compte dans les manques, le
        bouton reste éteint tant qu'il est vide. Un groupe rendu AVEC (les pages
        `litaeau-fiche-*`, non publiées, qui partagent ce moteur) garde son
        comportement d'avant — la règle se lit dans le HTML, pas dans un réglage. */
  function obligatoire(nom) {
    var ins = form.querySelectorAll('input[name="' + nom + '"]');
    if (!ins.length) return false;
    for (var i = 0; i < ins.length; i++) if (ins[i].defaultChecked) return false;
    return true;
  }
  var REQ = { lombaire: obligatoire('lombaire'), vinyle: obligatoire('vinyle') };

  /* ── 05/10 (correction) · LE SOUTIEN LOMBAIRE SE COMMANDE PAR LE PANIER ──────
     🛑 « Pourquoi tu mets Sur demande. […] Le soutien lombaire est commandable, la
        preuve sur les lits tu peux le choisir et tu dois pouvoir directement le
        commander ». La première version de la refonte le disait « sur demande » :
        FAUX, la boutique vend ces suppléments depuis le 10/09.
     👉 Comme sur les fiches lits (`litaeau-configurator-v2.js`) : une LIGNE À PART,
        avec les produits de supplément de la boutique, que la section émet en Liquid
        (`#supplements`, lus par `all_products` — jamais un identifiant écrit à la main) :
        « Support lombaire (lit simple 90/100/120) » 80 €, « (lit large 140+) » 160 €.
        Le petit ou le grand se choisit sur la largeur DU MATELAS — en duo, la poche,
        moitié du lit — et le seuil du tarif (`options.lombaire.seuil_petit` : 120 en
        Softside, 100 en Hardside, tarif p. 37 et 39). En duo, un supplément PAR poche
        qui le prend, son côté en propriété de ligne. Possible de F3 à F7 seulement.
     ⚠️ LE PRIX DU PRODUIT DOIT ÊTRE CELUI QUE LA PAGE AFFICHE. Sinon (prix changé dans
        l'admin, produit retiré de la vente) aucune ligne n'est émise et le bouton le
        DIT : jamais un supplément facturé à un autre montant que celui annoncé. */
  var SUP = {};
  try { var bsu = document.getElementById('supplements'); if (bsu) SUP = JSON.parse(bsu.textContent) || {}; }
  catch (x) { SUP = {}; }
  function supLombaire(larg) {
    var p = prixLombaire(larg), o = T.options.lombaire, L = SUP.lombaire || {};
    if (p === null) return null;
    var s = larg <= o.seuil_petit ? L.petit : L.grand;
    if (!s || !s.id || s.prix !== p || s.dispo === false) return null;
    return s;
  }
  /* 🛑 « pour le matelas BIOVYN tu peux mettre d'office D'origine en compris » : le
     vinyle d'origine est COMPRIS. Ce n'est pas une question : la section coche
     « D’origine » d'office (`checked`), donc `obligatoire('vinyle')` le sort des manques.
     05/10 (soir) · BIOVYN EXISTE EN BOUTIQUE (« Crée le supplément en respectant le tarif
     du pdf ») : c'est l'autre pastille, payante, qui part en LIGNE À PART comme le soutien
     lombaire — « Supplément — Vinyle BIOVYN (matelas 90/100/120) » 63 €, « (matelas 140+
     ou lit duo) » 125 €, lus par `all_products` (`#supplements`.biovyn). Simple : petit ou
     grand selon la largeur du matelas ; duo : UN grand pour le lit, et seulement quand on
     remplace les deux poches. Prix du produit ≠ prix affiché → aucune ligne, et la page le dit.
     (`data-vinyle-inclus` : l'écriture du 05/10 midi, une ligne sans pastille — gardée en
     lecture pour une page qui l'aurait encore.) */
  var VIN_INCLUS = !!form.querySelector('[data-vinyle-inclus]');
  var VIN_CHOIX = !!form.querySelector('input[name="vinyle"]');
  /* le supplément BIOVYN de cette configuration : { quel, prix } — `null` quand le tarif
     n'a pas de prix (duo à une poche, largeur pas encore choisie) */
  function biovynPour(e) {
    var o = T.options.biovyn;
    if (!o) return null;
    if (DUO) {
      /* 05/10 : « Oui 63 € BIOVYN pour une poche lit double » — une poche seule prend le petit supplément ;
         les deux poches, le prix du système à deux poches (PDF « dual … 125 ») */
      if (e.poches === 1) return typeof o.petit === 'number' ? { quel: 'petit', prix: o.petit } : null;
      var pd = prixBiovynDuo();
      return e.poches === 2 && pd !== null ? { quel: 'grand', prix: pd } : null;
    }
    var p = e.largeur ? prixBiovyn(e.largeur) : null;
    return p === null ? null : { quel: p === o.petit ? 'petit' : 'grand', prix: p };
  }
  function supBiovyn(b) {
    var B = SUP.biovyn || {}, s = b && B[b.quel];
    if (!s || !s.id || s.prix !== b.prix || s.dispo === false) return null;
    return s;
  }

  /* ── l'état ──────────────────────────────────────────────────────────────
     Deux sources de cote, et JAMAIS les deux à la fois : la liste du tarif, ou
     les deux champs du sur-mesure. Le bouton « Une cote intermédiaire » décide
     laquelle parle ; cliquer une cote de la liste ramène à la liste. */
  function lu(nom) {
    var el = form.querySelector('input[name="' + nom + '"]:checked');
    return el ? el.value : null;
  }
  function saisi(nom) {
    var el = form.querySelector('input[name="' + nom + '"]');
    if (!el) return null;
    var v = String(el.value).trim().replace(',', '.');
    if (!v) return null;
    var n = parseFloat(v);
    return isFinite(n) ? n : NaN;   /* NaN = saisie illisible, ≠ champ vide */
  }

  function evalSurMesure() {
    var l = saisi('surLargeur'), L = saisi('surLongueur');
    if (l === null || L === null) return { etat: 'vide', l: l, L: L };
    if (isNaN(l) || isNaN(L)) return { etat: 'illisible', l: l, L: L };
    var griefs = [], liens = null;
    /* 🛑 05/10 (revue) · SOUS LE PLUS PETIT LIT DUO, ON MONTRE OÙ ALLER — AVEC LE LIEN.
       Sur Softside Q duo, un lit de 140 × 200 « à deux poches » recevait « voyez le
       matelas pour lit à une poche » sans aucun lien, et le seul chemin cliquable de la
       fiche menait au Softside Q à UNE poche. Or la boutique vend ce lit : le Softside
       pour lit duo dès 140 cm (2 × 70 cm). `T.duo.ailleurs` (dans le `#tarif` de la
       section) dit quelle autre fiche duo couvre cette largeur, et le critère qui la
       distingue — celui que la page donne déjà dans « Vérifier que c'est bien votre
       système ». Jamais une variante approchée : un lien, et le numéro. */
    if (l < BORNES.lmin && DUO) {
      var ail = T.duo && T.duo.ailleurs;
      var simple = T.duo && T.duo.simple;
      liens = [];
      if (ail && l >= (ail.des || 0) && l < ail.sous) {
        griefs.push('Sous ' + cm(BORNES.lmin) + ', un lit ' + GAMME + ' ne se fait pas à deux poches. Votre lit de '
          + dim(l) + ' en a deux ? ' + ail.indice + ' : voyez ' + ail.nom + ' (2 × ' + dim(l / 2) + ').'
          + ' Une seule poche : le matelas pour lit à une poche. Ni l’un ni l’autre : appelez-nous.');
        liens.push({ href: ail.url, t: ail.lien });
      } else {
        griefs.push('Sous ' + cm(BORNES.lmin) + ', un lit ' + GAMME + ' ne se fait pas à deux poches : voyez le matelas pour lit à une poche.'
          + ' Votre lit en a deux ? Appelez-nous.');
      }
      if (simple) liens.push({ href: simple, t: 'Lit à une poche' });
    } else if (l < BORNES.lmin) griefs.push('Nous ne faisons pas de matelas sous ' + cm(BORNES.lmin) + ' de large.');
    /* ⚠️ le plafond de largeur n'est pas un arrondi : la note de bas de page
       des p. 37-39 dit « les largeurs au-delà de 200 cm sont disponibles
       uniquement en dual / kombi dual ». */
    if (l > BORNES.lmax) griefs.push(DUO
      ? 'Au-delà de ' + cm(BORNES.lmax) + ' de large, c’est sur demande.'
      : 'Au-delà de ' + cm(BORNES.lmax) + ' de large, il faut deux matelas séparés — ce n’est pas celui-ci.');
    if (L < BORNES.Lmin) griefs.push('Nous ne faisons pas de matelas sous ' + cm(BORNES.Lmin) + ' de long.');
    if (L > BORNES.Lmax) griefs.push('Nous nous arrêtons à ' + cm(BORNES.Lmax) + ' de long.');
    if (griefs.length) return { etat: 'hors', l: l, L: L, griefs: griefs, liens: liens };
    var c = cotePlusGrande(l, L);
    if (!c) return { etat: 'hors', l: l, L: L,
      griefs: ['Aucune taille de cette gamme ne couvre ' + l + ' × ' + cm(L) + '.'] };
    var exact = (c.l === l && c.L === L);
    return { etat: exact ? 'tarif' : 'speciale', l: l, L: L, fl: c.l, fL: c.L };
  }

  function etat() {
    var mode = lu('cote') === 'speciale' ? 'speciale' : 'standard';
    var lr = lu('largeur'), Lr = lu('longueur');
    var e = {
      mode: mode,
      /* ce que porte la LISTE — il pilote l'affichage des boutons, jamais le prix
         quand on est en sur-mesure */
      largeurRadio: lr ? parseInt(lr, 10) : null,
      longueurRadio: Lr ? parseInt(Lr, 10) : null,
      fermete: lu('fermete'),
      /* 05/10 : trois états, plus deux booléens qui valaient « non » par défaut —
         `null` veut dire « pas encore répondu », et c'est un manque */
      lombaireV: lu('lombaire'),
      vinyleV: lu('vinyle'),
      sur: mode === 'speciale' ? evalSurMesure() : null
    };
    e.lombaire = e.lombaireV === 'oui';
    e.biovyn = e.vinyleV === 'biovyn';
    if (mode === 'speciale') {
      var ok = e.sur.etat === 'tarif' || e.sur.etat === 'speciale';
      e.largeur = ok ? e.sur.fl : null;          /* la cote FACTURÉE */
      e.longueur = ok ? e.sur.fL : null;
      e.largeurDite = ok ? e.sur.l : null;       /* la cote ANNONCÉE au client */
      e.longueurDite = ok ? e.sur.L : null;
      e.speciale = e.sur.etat === 'speciale';
    } else {
      e.largeur = e.largeurRadio; e.longueur = e.longueurRadio;
      e.largeurDite = e.largeurRadio; e.longueurDite = e.longueurRadio;
      e.speciale = false;
    }
    if (DUO) {
      var pc = lu('poches');
      e.poches = pc ? parseInt(pc, 10) : null;
      e.poche = lu('poche');
      e.fG = lu('fermete-g'); e.fD = lu('fermete-d');
      e.lG = lu('lombaire-g'); e.lD = lu('lombaire-d');
      /* 🛑 CHAQUE MODE GARDE SES PROPRES CHOIX. Passer de deux poches à une ne
         réinterprète jamais la fermeté de gauche comme celle de « votre poche » :
         trois groupes distincts (`fermete`, `fermete-g`, `fermete-d`), et seul le
         mode courant est lu. Aucun choix n'est posé en silence. */
      e.liste = e.poches === 2
        ? [{ cote: 'gauche', f: e.fG, l: e.lG, k: 'g' }, { cote: 'droite', f: e.fD, l: e.lD, k: 'd' }]
        : e.poches === 1 ? [{ cote: e.poche, f: e.fermete, l: e.lombaireV, k: 'u' }] : [];
      e.lombaire = e.liste.some(function (p) { return p.l === 'oui'; });
      /* la poche : la MOITIÉ du lit, calculée — le client ne divise jamais */
      e.pocheL = e.largeur ? e.largeur / 2 : null;           /* facturée */
      e.pocheLDite = e.largeurDite ? e.largeurDite / 2 : null; /* annoncée */
    }
    return e;
  }

  /* ── les sorties ─────────────────────────────────────────────────────────── */
  var sorties = {};
  ['prix', 'prixE', 'prixQ', 'monumentF', 'monumentDit', 'monumentNappes', 'monumentCalme',
   'rBaseT', 'rBaseD', 'rBaseP', 'rLigne2', 'r2T', 'r2D', 'r2P', 'rLigneLomb', 'rLombP', 'rLombD', 'rLigneVin', 'rVinP', 'rVinD', 'rLigneVinO',
   'rLigneSpec', 'rSpecP', 'rTotal', 'bouton', 'aide', 'phrase', 'barre', 'barrePrix', 'videLong',
   'surEtat', 'surTxt', 'va', 'pcTaille2', 'pcTaille1', 'pcPrix2', 'pcPrix1', 'rLit', 'rLitD', 'rLitV'].forEach(function (k) {
    sorties[k] = form.querySelector('[data-out="' + k + '"]')
      || document.querySelector('[data-out="' + k + '"]');
  });
  var panneauSur = form.querySelector('[data-sur]');
  /* 🛑 LE SUR-MESURE REMPLACE LA LISTE, IL NE LA DOUBLE PAS. */
  var panneauStd = form.querySelector('[data-std]');
  var bandesL = [].slice.call(form.querySelectorAll('[data-bande]'));
  var bandesF = [].slice.call(form.querySelectorAll('[data-bandef]'));

  /* ══ 04/10 · « IL FAUT CLIQUER » — LA CONSIGNE ET LE GUIDE ══════════════════
     🛑 « je vois plein qui n'ont pas compris qu'il fallait cliquer pour choisir
        sa taille ». Les pastilles ne disaient pas qu'elles attendaient un clic,
        et le bouton d'achat, éteint, ne répondait RIEN : un `<button disabled>`
        ne reçoit pas le clic, aucun script ne pouvait donc l'entendre.
     👉 Deux pièces :
        1. une CONSIGNE par choix, écrite dans la section (jamais créée ici :
           elle occupe sa place dès le premier octet, rien ne saute au
           chargement). Son état suit la configuration — « actif » pour le
           PREMIER choix qui manque, « a-choisir » pour les suivants, « verrou »
           pour ce qui attend un autre choix, « fait » une fois choisi ;
        2. une GARDE posée sur le bouton tant qu'il est éteint : elle reçoit le
           clic que le bouton ne peut pas recevoir et amène l'œil sur le premier
           choix manquant — défilement doux, contour laiton, consigne qui pulse.
     ⚠️ LE BOUTON RESTE `disabled`. `verif_choix_obligatoires.js` et
        `verif_matelas_stabilisation.js` lisent `bouton.disabled` : c'est lui
        qui dit « on ne peut pas commander ». La garde ne commande rien. */
  var CONS = {};
  [].forEach.call(form.querySelectorAll('[data-consigne]'), function (c) {
    CONS[c.getAttribute('data-consigne')] = c;
  });
  var calme = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  /* la pulsation ne joue que trois fois, et seulement sur une consigne `.en-vue`
     (entrée à 60 % dans l'écran) — jamais démarquée, pas de second tour */
  (function () {
    var cs = [].slice.call(form.querySelectorAll('[data-consigne]'));
    if (!('IntersectionObserver' in window)) {
      cs.forEach(function (c) { c.classList.add('en-vue'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (!x.isIntersecting) return;
        x.target.classList.add('en-vue');
        io.unobserve(x.target);
      });
    }, { threshold: 0.6 });
    cs.forEach(function (c) { io.observe(c); });
  })();
  /* le contour laiton ne s'entend pas : un lecteur d'écran reçoit la phrase.
     ⚠️ 05/10 : quand la section porte `data-out="aide"` (role=status, VISIBLE sous
        le bouton), c'est elle qui parle — deux régions vivantes pour une même
        phrase la feraient lire deux fois. Celle-ci ne sert plus qu'en repli. */
  var annonce = document.createElement('p');
  annonce.className = 'm9-lu';
  annonce.setAttribute('role', 'status');
  annonce.setAttribute('data-out', 'guide');
  form.appendChild(annonce);

  /* ── 05/10 · L'AIDE SOUS LE BOUTON — elle manquait dans les six sections ─────
     🛑 LE CLIC MUET. `sorties.aide` était lue partout dans ce moteur, et aucune
        section ne portait `data-out="aide"` : tout ce que la page avait à dire au
        moment du clic — « ajouté », « échec du panier », « cette option ne se
        commande pas en ligne » — était écrit dans le vide. Avec le soutien
        lombaire coché, le bouton annonçait « Commander ce matelas », on cliquait,
        et rien ne se passait à l'écran. L'élément est désormais dans la section ;
        une phrase y vit, avec son mode (`guide`, `sd`, `ok`, `err`), ou il se retire. */
  var aideMode = null;
  function aide(txt, mode, html) {
    var a = sorties.aide;
    if (!a) {
      if (txt) { annonce.textContent = ''; setTimeout(function () { annonce.textContent = txt; }, 60); }
      return;
    }
    aideMode = txt || html ? mode : null;
    if (html) a.innerHTML = html; else a.textContent = txt || '';
    a.hidden = !(txt || html);
    if (aideMode) a.setAttribute('data-mode', aideMode); else a.removeAttribute('data-mode');
  }

  /* ce qui manque, DANS L'ORDRE DE LA PAGE — le premier est celui qu'on désigne */
  function manques(e) {
    var m = [];
    /* 🛑 05/10 (revue) · « HORS GAMME » N'EST PAS « À REMPLIR ». Des cotes données, mais que
       la fiche ne fait pas (lit de 140 sur Softside Q duo), faisaient dire au guide « Il
       reste à choisir : les deux cotes de votre lit » et à la barre « Donner les cotes » —
       alors qu'elles venaient d'être données. Le manque `hors` mène au verdict, qui porte
       la solution (un lien, un numéro). */
    if (e.mode === 'speciale') {
      if (e.sur && e.sur.etat === 'hors') m.push('hors');
      else if (!(e.largeur && e.longueur)) m.push('sur');
    }
    else {
      if (!e.largeurRadio) m.push('largeur');
      if (!e.longueurRadio) m.push('longueur');
    }
    if (DUO) {
      if (!e.poches) m.push('poches');
      else if (e.poches === 1 && !e.poche) m.push('poche');
      if (e.poches === 2) { if (!e.fG) m.push('fermete-g'); if (!e.fD) m.push('fermete-d'); }
      else if (!e.fermete) m.push('fermete');
      if (REQ.lombaire) {
        if (e.poches === 2) { if (!e.lG) m.push('lombaire-g'); if (!e.lD) m.push('lombaire-d'); }
        else if (!e.lombaireV) m.push('lombaire');
      }
    } else {
      if (!e.fermete) m.push('fermete');
      if (REQ.lombaire && !e.lombaireV) m.push('lombaire');
    }
    if (REQ.vinyle && !e.vinyleV) m.push('vinyle');
    return m;
  }
  var DIT = {
    largeur: DUO ? 'la largeur de votre lit' : 'la largeur du cadre',
    longueur: DUO ? 'la longueur de votre lit' : 'la longueur du cadre',
    sur: DUO ? 'les deux cotes de votre lit' : 'les deux cotes de votre cadre',
    hors: DUO ? 'une taille de lit que cette fiche ne fait pas' : 'une taille que cette fiche ne fait pas',
    poches: 'le nombre de poches à remplacer',
    poche: 'la poche à remplacer, gauche ou droite',
    fermete: DUO ? 'la fermeté de votre poche' : 'votre fermeté',
    'fermete-g': 'la fermeté de la poche de gauche',
    'fermete-d': 'la fermeté de la poche de droite',
    lombaire: 'avec ou sans soutien lombaire',
    'lombaire-g': 'le soutien lombaire de la poche de gauche',
    'lombaire-d': 'le soutien lombaire de la poche de droite',
    vinyle: 'le vinyle'
  };
  function direManques(m) {
    if (!m.length) return '';
    /* hors gamme : ce n'est pas un choix qui manque, c'est une solution à lire */
    if (m[0] === 'hors') {
      return (DUO ? 'Cette taille de lit ne se fait pas sur cette fiche' : 'Cette taille ne se fait pas sur cette fiche')
        + ' : la solution est écrite sous vos cotes.';
    }
    var t = m.slice(0, 3).map(function (n) { return DIT[n]; }).join(', ');
    return 'Il reste à choisir : ' + t + (m.length > 3 ? ', et ' + (m.length - 3) + ' autre' + (m.length > 4 ? 's' : '') : '') + '.';
  }

  function poser(nom, etatC, txt) {
    var c = CONS[nom];
    if (!c) return;
    if (c.getAttribute('data-etat') !== etatC) c.setAttribute('data-etat', etatC);
    var t = c.querySelector('[data-consigne-t]');
    if (t && t.textContent !== txt) t.textContent = txt;
    /* choisi : le guide a fini son travail ici, le contour s'en va */
    if (etatC === 'fait') {
      c.classList.remove('is-guide');
      if (c.nextElementSibling) c.nextElementSibling.classList.remove('is-guide');
    }
  }
  function majConsignes(e) {
    var m = manques(e), premier = m[0];
    function etatDe(nom) { return nom === premier ? 'actif' : 'a-choisir'; }
    var LT = DUO ? ' de votre lit' : ' du cadre';
    if (e.largeurRadio) poser('largeur', 'fait', DUO
      ? 'Lit de ' + e.largeurRadio + ' cm : deux poches de ' + cm(e.largeurRadio / 2)
      : 'Largeur choisie : ' + e.largeurRadio + ' cm');
    else poser('largeur', etatDe('largeur'), 'Choisissez la largeur' + LT);
    if (e.longueurRadio) poser('longueur', 'fait', 'Longueur choisie : ' + e.longueurRadio + ' cm');
    /* 🛑 « PAS ENCORE » N'EST PAS « JAMAIS » — le verrou dit sa raison en toutes lettres */
    else if (!e.largeurRadio) poser('longueur', 'verrou', 'Choisissez d’abord la largeur' + LT);
    else poser('longueur', etatDe('longueur'), 'Choisissez la longueur' + LT);
    if (DUO) {
      if (e.poches) poser('poches', 'fait', e.poches === 2 ? 'Choisi : les deux poches' : 'Choisi : une seule poche');
      else poser('poches', etatDe('poches'), 'Choisissez une ou deux poches');
      if (e.poche) poser('poche', 'fait', 'Poche choisie : ' + e.poche);
      else poser('poche', etatDe('poche'), 'Choisissez la poche à remplacer');
      if (!e.poches) poser('fermete', 'verrou', 'Choisissez d’abord une ou deux poches');
      else if (e.fermete) poser('fermete', 'fait', 'Fermeté choisie : ' + e.fermete);
      else poser('fermete', etatDe('fermete'), 'Choisissez la fermeté de cette poche, de F0 à F8');
      if (e.fG) poser('fermete-g', 'fait', 'Fermeté choisie : ' + e.fG);
      else poser('fermete-g', etatDe('fermete-g'), 'Choisissez la fermeté de la poche de gauche');
      if (e.fD) poser('fermete-d', 'fait', 'Fermeté choisie : ' + e.fD);
      else poser('fermete-d', etatDe('fermete-d'), 'Choisissez la fermeté de la poche de droite');
    } else {
      if (e.fermete) poser('fermete', 'fait', 'Fermeté choisie : ' + e.fermete);
      else poser('fermete', etatDe('fermete'), 'Choisissez votre fermeté, de F0 à F8');
    }
    /* le montant du soutien lombaire se dit au moment du choix : il part au panier */
    var plo = DUO ? (e.pocheL ? prixLombaire(e.pocheL) : null) : (e.largeur ? prixLombaire(e.largeur) : null);
    [['lombaire', e.lombaireV], ['lombaire-g', e.lG], ['lombaire-d', e.lD]].forEach(function (x) {
      if (!CONS[x[0]]) return;
      if (x[1]) poser(x[0], 'fait', x[1] === 'oui' ? 'Choisi : avec' + (plo !== null ? ', +' + eur(plo) : '') : 'Choisi : sans');
      else poser(x[0], etatDe(x[0]), 'Choisissez sans ou avec');
    });
    if (e.vinyleV) poser('vinyle', 'fait', e.vinyleV === 'biovyn' ? 'Choisi : BIOVYN' : 'Choisi : d’origine');
    else poser('vinyle', etatDe('vinyle'), 'Choisissez votre vinyle');
    if (premier !== 'sur' && premier !== 'hors' && panneauSur) {
      [].forEach.call(panneauSur.querySelectorAll('.is-guide'), function (x) { x.classList.remove('is-guide'); });
    }
    return m;
  }

  /* 🛑 AMENER L'ŒIL, PAS SEULEMENT LA PAGE. Un saut d'ancre posait l'étape sous
     l'en-tête collant (79 px au bureau, 120 au téléphone — `--header-height`,
     que le thème tient à jour) et ne disait pas QUEL choix manquait. */
  function allerA(y) {
    /* ⚠️ `behavior:'auto'` NE VEUT PAS DIRE « sans animation » : il renvoie au CSS,
       et le thème pose `scroll-behavior:smooth` — mesuré : en mouvement réduit, la
       page glissait quand même. On coupe le CSS le temps du saut. */
    if (calme) {
      var racine = document.documentElement, sb = racine.style.scrollBehavior;
      racine.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      racine.style.scrollBehavior = sb;
    } else {
      try { window.scrollTo({ top: y, behavior: 'smooth' }); }
      catch (x) { window.scrollTo(0, y); }
    }
  }
  function guider() {
    var e = etat(), m = manques(e);
    if (!m.length) return false;
    var nom = m[0];
    /* hors gamme : l'œil va au VERDICT (« Hors gamme » + la solution), pas aux champs */
    var verdict = panneauSur ? panneauSur.querySelector('.sur__r') : null;
    var cible = nom === 'sur' ? panneauSur : nom === 'hors' ? verdict : CONS[nom];
    if (!cible) return false;
    var groupe = nom === 'sur' ? panneauSur.querySelector('.sur__g') : nom === 'hors' ? null : cible.nextElementSibling;
    [].forEach.call(form.querySelectorAll('.is-guide'), function (x) { x.classList.remove('is-guide'); });
    void cible.offsetWidth;            /* relance l'animation si l'on clique deux fois */
    cible.classList.add('is-guide');
    if (groupe) groupe.classList.add('is-guide');
    var haut = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    /* on cadre AUSSI la légende du groupe (« LARGEUR DU CADRE ») quand elle
       précède la consigne ; pour une option, toute sa rangée (son nom est à gauche) */
    var tete = cible.previousElementSibling;
    var ancre = tete && tete.classList.contains('lgd') ? tete : (cible.closest('.opt__r') || cible);
    allerA(Math.max(0, ancre.getBoundingClientRect().top + window.pageYOffset - haut - 14));
    /* le focus suit l'œil, sans second défilement */
    var champ = cible;
    if (nom === 'hors' && !cible.hasAttribute('tabindex')) cible.setAttribute('tabindex', '-1');
    if (nom === 'sur') {
      champ = [].filter.call(panneauSur.querySelectorAll('input'), function (i) { return !i.value; })[0]
        || panneauSur.querySelector('input') || cible;
    }
    try { champ.focus({ preventScroll: true }); } catch (x) { }
    aide(direManques(m), 'guide');
    return true;
  }

  /* la GARDE du bouton éteint : posée au-dessus de lui, dans une enveloppe qui
     reprend sa marge — la mise en page ne bouge pas d'un pixel */
  var garde = null;
  if (sorties.bouton && sorties.bouton.parentNode) {
    var enveloppe = document.createElement('div');
    enveloppe.className = 'achat__bt';
    sorties.bouton.parentNode.insertBefore(enveloppe, sorties.bouton);
    enveloppe.appendChild(sorties.bouton);
    garde = document.createElement('span');
    garde.className = 'achat__garde';
    garde.setAttribute('aria-hidden', 'true');
    garde.hidden = !sorties.bouton.disabled;
    enveloppe.appendChild(garde);
    garde.addEventListener('click', function () { if (sorties.bouton.disabled) guider(); });
  }
  /* le lien « Aller à l'étape » mène au même endroit, de la même façon */
  if (sorties.va) sorties.va.addEventListener('click', function (ev) {
    if (guider()) ev.preventDefault();
  });

  var DES = '<small class="des">Dès</small> ';   /* 29/10 : « Dès » devant un prix d'entrée, petit et discret */
  function ecrire(el, txt, attente) {
    if (!el) return;
    el.textContent = txt;
    if (el.tagName === 'DD') el.classList.toggle('att', !!attente);
  }
  function ligne(el, montre, montant) {
    if (!el) return;
    el.hidden = !montre;
    if (montre && montant != null) {
      var dd = el.querySelector('dd');
      if (dd) { dd.textContent = typeof montant === 'string' ? montant : '+ ' + eur(montant); dd.classList.remove('att'); }
    }
  }

  /* ── le calcul complet ────────────────────────────────────────────────────
     Tout se calcule sur `e.largeur`, la largeur FACTURÉE. En sur-mesure c'est
     celle de la cote supérieure du tarif ; en cote standard c'est la même que
     celle qu'on a cochée. Les options suivent, sans exception.
     🛑 DUO : le total est la SOMME des poches commandées (« Somme des 2 poches » :
        Softside, lit 160, F0 + F5 = 482 + 600 = 1 082 €), PLUS le soutien lombaire de
        chaque poche qui le prend (05/10, correction : il se commande par le panier, au
        prix du supplément de la largeur de la POCHE). Le sur-mesure n'y entre jamais :
        (05/10 soir) il a désormais son supplément et s'ajoute une fois, en ligne à part. */
  function calcul(e) {
    var vide = { total: null, base: null, lombaire: null, biovyn: null, speciale: null, lignes: [] };
    if (DUO) {
      if (!e.largeur) return vide;
      var lignes = e.liste.map(function (p) {
        var lo = p.l === 'oui' && p.f && lombairePossible(p.f) ? prixLombaire(e.pocheL) : null;
        return { cote: p.cote, f: p.f, k: p.k, prix: p.f ? prixBase(e.largeur, p.f) : null, lombaire: lo };
      });
      var ok = lignes.length > 0 && lignes.every(function (l) { return l.prix !== null; });
      var lom = null;
      lignes.forEach(function (l) { if (l.lombaire !== null) lom = (lom || 0) + l.lombaire; });
      /* BIOVYN : UN supplément pour le lit, deux poches seulement (`biovynPour`) */
      var bvd = e.biovyn ? biovynPour(e) : null;
      var bv = bvd ? bvd.prix : null;
      /* 05/10 : la dimension spéciale a son supplément (180 €, PDF p.37-39, ajouté à la taille supérieure) :
         UNE fois pour la commande de la fiche, comme le tarif la donne par matelas commandé */
      var sp = e.speciale ? T.options.speciale.prix : null;
      var tot = ok ? lignes.reduce(function (s, l) { return s + l.prix; }, 0) + (lom || 0) + (bv || 0) + (sp || 0) : null;
      return { total: tot, base: lignes[0] ? lignes[0].prix : null, lombaire: lom, biovyn: bv,
        speciale: sp, lignes: lignes };
    }
    var base = e.largeur ? prixBase(e.largeur, e.fermete) : null;
    if (base === null) return vide;
    var c = { total: base, base: base, lombaire: null, biovyn: null, speciale: null, lignes: [] };
    if (e.lombaire && lombairePossible(e.fermete)) {
      var pl = prixLombaire(e.largeur);
      if (pl !== null) { c.total += pl; c.lombaire = pl; }
    }
    if (e.biovyn) {
      var pb = prixBiovyn(e.largeur);
      if (pb !== null) { c.total += pb; c.biovyn = pb; }
    }
    if (e.speciale) { c.total += T.options.speciale.prix; c.speciale = T.options.speciale.prix; }
    return c;
  }

  /* 🛑 05/10 · CE QUI NE PASSE PAS PAR LE PANIER SE DIT « SUR DEMANDE ».
     ⚠️ CORRECTION DU 05/10 : le soutien lombaire N'EN EST PLUS — il a ses produits de
        supplément et part au panier (voir `supLombaire`). Reste le sur-mesure, qui n'a
        pas de supplément en boutique, et le BIOVYN des seules pages qui ne déclarent pas
        ses suppléments (05/10 soir : les six fiches les déclarent, BIOVYN y part au panier).
     Avant : le bouton annonçait « Commander ce matelas », et le clic ne faisait rien
     à l'écran (aucune section ne portait `data-out="aide"`).
     La règle, désormais : ce qui ne peut pas être commandé est DIT, au moment du
     choix (une ligne sous l'option) et au moment du clic (l'aide sous le bouton,
     avec un numéro et un lien) — jamais un échec muet, jamais une variante
     approchée. Hors boutique (maquettes sans `#variantes`), rien ne change. */
  var SD_DIT = { lombaire: 'le soutien lombaire', biovyn: 'le vinyle BIOVYN', speciale: 'le sur-mesure' };
  function surDemande(e) {
    if (!ACHAT) return [];
    var r = [];
    if (e.speciale && !(SUP.speciale && SUP.speciale.id)) r.push('speciale');
    /* 05/10 (soir) : BIOVYN a ses suppléments (`#supplements`.biovyn) et part au panier ;
       « sur demande » ne reste que pour une page qui ne les déclare pas */
    if (e.biovyn && !SUP.biovyn) r.push('biovyn');
    return r;
  }
  function liste(xs) {
    return xs.length < 2 ? xs.join('') : xs.slice(0, -1).join(', ') + ' et ' + xs[xs.length - 1];
  }
  var CONTACT = '<span class="achat__sdl"><a href="tel:+33467786848">04 67 78 68 48</a>'
    + '<a href="/pages/contact">Nous écrire</a></span>';
  function direSurDemande(raisons) {
    var r = raisons.map(function (x) { return SD_DIT[x]; });
    var html = raisons.length
      ? '<b>Sur demande.</b> ' + liste(r).replace(/^./, function (c) { return c.toUpperCase(); })
        + (r.length > 1 ? ' ne passent' : ' ne passe') + ' pas par le panier : nous '
        + (r.length > 1 ? 'les' : 'le') + ' commandons avec vous, prix et délai confirmés avant tout paiement. Rien n’a été ajouté.' + CONTACT
      : '<b>À confirmer avec nous.</b> Cette combinaison ne passe pas par le panier en ligne : nous la commandons avec vous, prix et délai confirmés avant tout paiement. Rien n’a été ajouté.' + CONTACT;
    aide(null, 'sd', html);
    if (sorties.aide) { try { sorties.aide.focus({ preventScroll: true }); } catch (x) { } }
  }

  /* 🛑 LE LIEN QUI MENE A L'ETAPE MANQUANTE. Le panneau d'achat colle au
     lecteur ; l'etape dont il parle, non.
     ⚠️ LE LIBELLE SE LIT DANS LE DOM. Le titre de l'etape est ecrit une
        seule fois, dans sa legende (`data-lgd`, ou `data-lgd-nom` quand l'étiquette
        visible ne se lit pas seule — « Laquelle ? ») ; le recopier ici l'aurait fait
        diverger au premier remaniement. L'étape est celle du `<fieldset>` qui porte
        la consigne : quatre en duo, trois en simple, rien à tenir à jour ici. */
  function majVa(m) {
    var a = sorties.va;
    if (!a) return;
    if (!m.length) { a.hidden = true; return; }
    var nom = m[0];
    var c = nom === 'sur' || nom === 'hors' ? panneauSur : CONS[nom];
    var fs = c && c.closest('fieldset');
    if (!fs || !fs.id) { a.hidden = true; return; }
    var pas = fs.id.replace('pas-', '');
    var t = '';
    var lgd = nom === 'sur' || nom === 'hors' ? null : form.querySelector('[data-lgd="' + nom + '"]');
    if (lgd) {
      var et = lgd.querySelector('.etiq');
      t = lgd.getAttribute('data-lgd-nom') || (et ? et.textContent : '');
    }
    if (!t) { var pt = fs.querySelector('.pas__t'); t = pt ? pt.textContent : ''; }
    a.hidden = false;
    a.setAttribute('href', '#' + fs.id);
    a.childNodes[0].nodeValue = 'Aller à l’étape ' + pas
      + (t ? ' — ' + t.trim().toLowerCase() : '');
  }

  /* ── DUO : les blocs qui apparaissent selon le nombre de poches ─────────────
     🛑 ILS SONT ÉCRITS DANS LE HTML, le JS les montre ou les cache — jamais créés
        ici (« l'état sans JS reste complet »). Progressive disclosure : « Laquelle ? »
        n'existe que pour « Une seule », la poche de droite que pour « Les deux ». */
  var DU = DUO ? {
    laquelle: form.querySelector('[data-laquelle]'),
    fbU: form.querySelector('[data-fb="u"]'), fbG: form.querySelector('[data-fb="g"]'),
    fbD: form.querySelector('[data-fb="d"]'),
    oU: form.querySelector('[data-opt="lombaire"]'), oG: form.querySelector('[data-opt="lombaire-g"]'),
    oD: form.querySelector('[data-opt="lombaire-d"]'),
    titreU: form.querySelector('[data-fb-titre]')
  } : null;
  function montrer(el, oui) { if (el) el.hidden = !oui; }
  function rendreDuo(e) {
    montrer(DU.laquelle, e.poches === 1);
    montrer(DU.fbU, e.poches !== 2);
    montrer(DU.fbG, e.poches === 2); montrer(DU.fbD, e.poches === 2);
    montrer(DU.oU, e.poches !== 2);
    montrer(DU.oG, e.poches === 2); montrer(DU.oD, e.poches === 2);
    if (DU.titreU) {
      var tu = 'Votre poche' + (e.poches === 1 && e.poche ? ' — ' + e.poche : '');
      if (DU.titreU.textContent !== tu) DU.titreU.textContent = tu;
    }
    /* la fermeté de « votre poche » ATTEND le nombre de poches : affichée, en
       pointillé, avec sa raison dans la consigne (verrou) — jamais masquée */
    [].forEach.call(form.querySelectorAll('input[name="fermete"]'), function (i) {
      i.disabled = !e.poches;
      var lab = i.closest('.ch');
      if (lab) lab.classList.toggle('ch--attente', !e.poches);
    });
    /* les cartes disent la taille de CHAQUE poche — la division, faite par la page */
    var pd = e.pocheLDite ? dim(e.pocheLDite, e.longueurDite) : null;
    ecrire(sorties.pcTaille2, pd ? '2 poches de ' + pd : 'Deux poches, chacune de la moitié de votre lit');
    ecrire(sorties.pcTaille1, pd ? '1 poche de ' + pd : 'Une poche, la moitié de votre lit');
    var p0 = e.largeur ? prixBase(e.largeur, T.paliers[0].f) : T.plancher;
    ecrire(sorties.pcPrix2, p0 === null ? '' : 'dès ' + eur(2 * p0));
    ecrire(sorties.pcPrix1, p0 === null ? '' : 'dès ' + eur(p0));
    /* les rangées « soutien lombaire » des deux poches rappellent leur fermeté */
    [['g', e.fG], ['d', e.fD]].forEach(function (x) {
      var s = form.querySelector('[data-fdit="' + x[0] + '"]');
      if (s) s.textContent = x[1] ? ' (' + x[1] + ')' : '';
    });
  }
  /* les groupes de prix des fermetés choisies — une bande n'écrit son prix exact
     que si TOUTES les poches commandées sont dans le même groupe */
  function groupesChoisis(e) {
    if (!e.liste || !e.liste.length) return [];
    if (!e.liste.every(function (p) { return p.f; })) return [];
    var g = [];
    e.liste.forEach(function (p) { var x = groupeDe(p.f); if (g.indexOf(x) < 0) g.push(x); });
    return g;
  }

  function monument(suf, f) {
    var q = function (k) { return form.querySelector('[data-out="' + k + suf + '"]'); };
    var pal = palierDe(f);
    if (pal) {
      ecrire(q('monumentF'), pal.f);
      ecrire(q('monumentDit'), pal.dit);
      ecrire(q('monumentNappes'), pal.n === 0 ? 'aucune couche' : pal.n + (pal.n > 1 ? ' couches' : ' couche'));
      ecrire(q('monumentCalme'), pal.calme);
    } else {
      /* 30/09 : pas encore de palier choisi — rien ne s'affiche comme s'il l'était */
      ecrire(q('monumentF'), 'F ?');   /* « quel palier ? » — un grand tiret se lisait comme une barre */
      ecrire(q('monumentDit'), 'à choisir');
      ecrire(q('monumentNappes'), '—');
      ecrire(q('monumentCalme'), '—');
    }
  }

  /* le soutien lombaire d'UNE poche (ou du matelas, en simple) : grisé hors F3-F7,
     AVEC LE MOT qui dit pourquoi */
  function majLombaire(nom, f, e) {
    var lOk = lombairePossible(f);
    [].forEach.call(form.querySelectorAll('input[name="' + nom + '"]'), function (i) {
      var lab = i.closest('.ch'), pr = lab && lab.querySelector('.ch__p');
      if (i.value === 'non') { if (pr) pr.textContent = 'sans supplément'; return; }
      var ok = lOk && !!e.largeur;
      var attente = (lOk && !e.largeur) || !f;   /* 30/09 : sans palier, on ATTEND, on ne refuse pas */
      i.disabled = !ok;
      if (lab) {
        lab.classList.toggle('ch--attente', attente);
        lab.classList.toggle('ch--non', !ok && !attente);
      }
      if (!ok && i.checked) {
        /* 🛑 05/10 : ON RELÂCHE, ON NE POSE RIEN. « Avec » devenu impossible se
           décoche, « Sans » n'est PAS coché à sa place : la consigne revient, et
           c'est le client qui répond. (Les pages qui cochent « Sans » d'avance
           gardent l'ancien geste.) */
        i.checked = false;
        if (!REQ.lombaire) {
          var sans = form.querySelector('input[name="' + nom + '"][value="non"]');
          if (sans) sans.checked = true;
        }
      }
      if (pr) {
        pr.textContent = !f ? (DUO ? 'choisissez d’abord la fermeté' : 'choisissez d’abord la stabilisation')
          : !lOk ? 'n’existe pas en ' + f
          : !e.largeur ? 'donnez d’abord vos dimensions'
          : '+' + eur(prixLombaire(DUO ? e.pocheL : e.largeur));
      }
    });
  }

  /* une ligne « Sur demande — … » s'ouvre sous l'option choisie. ⚠️ La barre du
     téléphone est fixée en bas : si elle couvre la ligne qui vient de s'ouvrir, on
     fait défiler juste ce qu'il faut pour la montrer (`fixed-element-offset`). */
  function voirSd(el) {
    if (!el || el.hidden) return;
    var b = sorties.barre;
    var hb = b && b.classList.contains('on') ? b.getBoundingClientRect().height : 0;
    var r = el.getBoundingClientRect();
    var bas = window.innerHeight - hb - 12;
    if (r.bottom > bas) allerA(window.pageYOffset + (r.bottom - bas));
  }

  /* ── la mise à jour ─────────────────────────────────────────────────────── */
  function rendre() {
    var e = etat();
    var enSur = e.mode === 'speciale';
    form.classList.toggle('sur-on', enSur);
    if (panneauSur) {
      panneauSur.hidden = !enSur;
      panneauSur.setAttribute('data-etat', enSur ? e.sur.etat : 'vide');
    }
    if (panneauStd) panneauStd.hidden = enSur;
    if (DUO) rendreDuo(e);

    /* ── 1 · LES BANDES PORTENT LE PRIX, PLUS LES PASTILLES ────────────────
       🛑 « pour les dimensions comment tu presentes ca j'aime pas du tout » :
          huit largeurs portaient huit montants dont SIX étaient identiques deux
          à deux. Le montant s'écrit UNE fois par bande.
       En DUO, c'est le prix d'UNE poche, et la bande le dit (« la poche »). */
    var gs = DUO ? groupesChoisis(e) : [];
    bandesL.forEach(function (n) {
      var i = +n.getAttribute('data-bande');
      var larges = T.bandes[i] && (T.bandes[i].largeurs && T.bandes[i].largeurs.length
        ? T.bandes[i].largeurs
        : (T.bandes[i].couples || []).map(function (c) { return c[0]; }));
      if (DUO) {
        var g1 = gs.length === 1 ? gs[0] : null;
        var pd = (larges && larges.length) ? T.bandes[i].prix[g1 || T.paliers[0].g] : null;
        n.textContent = typeof pd !== 'number' ? '—' : (g1 ? '' : 'dès ') + eur(pd) + ' la poche';
        return;
      }
      /* 🛑 30/09 : la stabilisation n'est plus cochée d'avance. Sans elle, la bande montre son PLANCHER
         (au palier le plus souple, F0), qualifié par « dès » — atteignable, et jamais un tiret d'attente. */
      var fAff = e.fermete || (T.paliers[0] && T.paliers[0].f);
      var p = (larges && larges.length) ? prixBase(larges[0], fAff) : null;
      n.textContent = p === null ? '—' : (e.fermete ? '' : 'dès ') + eur(p);
    });
    /* ── 1 bis · LES PALIERS DE FERMETÉ, MÊME DESSIN (tous les blocs : en duo,
       chaque poche a la même grille, au prix de la poche de CE lit) */
    bandesF.forEach(function (n) {
      var g = n.getAttribute('data-groupe');
      var p = e.largeur && g ? (bandeDe(e.largeur) || { b: { prix: {} } }).b.prix[g] : null;
      /* en duo, le montant est celui d'UNE poche, et la bande le dit — comme les bandes
         de largeur (« dès 482 € la poche ») : sous « Poche de gauche / de droite », un
         « 600 € » seul se lisait comme le prix du lit */
      /* ⚠️ écrite EN LIGNE (« 482 € la poche »), elle faisait passer le montant sous les
         pastilles sur les trois bandes à 390 px (+140 px par poche, mesuré à la capture) :
         elle se range SOUS le montant (`.bd__u`), et la bande garde sa ligne. L'espace de tête
         reste dans le texte : un lecteur d'écran lit « 482 € la poche ». */
      var unite = DUO ? '<small class="bd__u"> la poche</small>' : '';
      if (typeof p === 'number') {
        n.innerHTML = esc(eur(p)) + unite;
        n.closest('.bd').classList.remove('bd--muet');
        return;
      }
      /* sans largeur : le PLANCHER RÉEL du groupe, qualifié par « dès » */
      var bas = null;
      (T.bandes || []).forEach(function (b) {
        var v = b && b.prix ? b.prix[g] : null;
        if (typeof v === 'number' && (bas === null || v < bas)) bas = v;
      });
      n.innerHTML = (bas === null) ? '' : esc('dès ' + eur(bas)) + unite;
      n.closest('.bd').classList.toggle('bd--muet', bas === null);
    });

    /* ── 2 · LES LONGUEURS : filtrées par la largeur, AFFICHÉES quand même,
       désactivées avec leur raison en toutes lettres. */
    var dispo = e.largeurRadio ? longueursDe(e.largeurRadio) : [];
    var aucune = true;
    [].forEach.call(form.querySelectorAll('input[name="longueur"]'), function (i) {
      var L = parseInt(i.value, 10);
      var ok = e.largeurRadio ? dispo.indexOf(L) >= 0 : false;
      /* 🛑 « PAS ENCORE » N'EST PAS « JAMAIS ». */
      var attente = !e.largeurRadio;
      var lab = i.closest('.ch'), pr = lab && lab.querySelector('.ch__p');
      i.disabled = !ok;
      if (lab) {
        lab.classList.toggle('ch--attente', attente);
        lab.classList.toggle('ch--non', !ok && !attente);
      }
      if (ok) aucune = false;
      if (pr) {
        pr.textContent = !e.largeurRadio ? 'après la largeur'
          : ok ? 'sans effet sur le prix'
          : 'pas de ' + e.largeurRadio + ' × ' + L;
      }
      /* on RELÂCHE : une longueur impossible pour la nouvelle largeur se décoche */
      if (!ok && i.checked) i.checked = false;
    });
    if (sorties.videLong) {
      var vl = enSur || !e.largeurRadio ? ''
          : (aucune ? 'Aucune longueur ne va avec cette largeur.'
            : 'En ' + e.largeurRadio + ' cm : ' + dispo.join(' · ') + ' cm.');
      sorties.videLong.textContent = vl;
      sorties.videLong.hidden = !vl;
    }

    /* ── 3 · LA COTE INTERMÉDIAIRE — le verdict, en toutes lettres. */
    [].forEach.call(form.querySelectorAll('input[name="cote"]'), function (i) {
      var lab = i.closest('.ch'), pr = lab && lab.querySelector('.ch__p');
      if (!pr) return;
      pr.textContent = i.value === 'speciale'
        ? (SUP.speciale && SUP.speciale.id ? '+ ' + eur(T.options.speciale.prix) : 'sur demande')
        : 'sans supplément';
    });
    if (sorties.surEtat && sorties.surTxt) {
      var s = e.sur || { etat: 'vide' };
      var quoi = DUO ? 'de votre lit' : 'de votre cadre';
      if (!enSur || s.etat === 'vide') {
        ecrire(sorties.surEtat, 'À compléter');
        ecrire(sorties.surTxt, 'Donnez les deux cotes ' + quoi + ', en centimètres — de '
          + BORNES.lmin + ' à ' + cm(BORNES.lmax) + ' de large, de '
          + BORNES.Lmin + ' à ' + cm(BORNES.Lmax) + ' de long.');
      } else if (s.etat === 'illisible') {
        ecrire(sorties.surEtat, 'À corriger');
        ecrire(sorties.surTxt, 'Une cote s’écrit en chiffres, en centimètres — 145 par exemple.');
      } else if (s.etat === 'hors') {
        ecrire(sorties.surEtat, 'Hors gamme');
        if (s.liens && s.liens.length) {
          /* la solution se CLIQUE : les liens de la fiche voisine, puis le numéro
             (`.achat__sdl` : cibles de 44 px, le même dessin que sous la liste) */
          sorties.surTxt.innerHTML = esc(s.griefs.join(' ')) + '<span class="achat__sdl">'
            + s.liens.map(function (x) { return '<a href="' + esc(x.href) + '">' + esc(x.t) + '</a>'; }).join('')
            + '<a href="tel:+33467786848">04 67 78 68 48</a></span>';
        } else ecrire(sorties.surTxt, s.griefs.join(' ') + ' Appelez-nous : c’est du cas par cas.');
      } else if (s.etat === 'tarif') {
        ecrire(sorties.surEtat, 'Taille standard');
        ecrire(sorties.surTxt, s.l + ' × ' + cm(s.L)
          + ' est une taille standard : aucun supplément.'
          + (DUO ? ' Deux poches de ' + dim(s.l / 2, s.L) + '.' : ''));
      } else if (DUO) {
        ecrire(sorties.surEtat, 'Sur-mesure');
        ecrire(sorties.surTxt, s.l + ' × ' + cm(s.L) + ' est entre deux tailles standard : facturé sur la taille standard juste au-dessus, '
          + s.fl + ' × ' + cm(s.fL) + ' (deux poches de ' + dim(s.fl / 2, s.fL) + '), plus ' + eur(T.options.speciale.prix) + '.');
      } else {
        ecrire(sorties.surEtat, 'Sur-mesure');
        ecrire(sorties.surTxt, s.l + ' × ' + cm(s.L) + ' est facturé sur la taille standard juste au-dessus, '
          + s.fl + ' × ' + cm(s.fL) + ', plus ' + eur(T.options.speciale.prix)
          + '.');
      }
    }

    /* ── 4 · LA FERMETÉ : la pastille porte ses couches ; le montant vit sur la bande */
    ['fermete', 'fermete-g', 'fermete-d'].forEach(function (nom) {
      [].forEach.call(form.querySelectorAll('input[name="' + nom + '"]'), function (i) {
        var lab = i.closest('.ch'), pr = lab && lab.querySelector('.ch__p');
        if (!pr) return;
        var n = palierDe(i.value).n;
        pr.textContent = n === 0 ? 'aucune couche' : n + (n > 1 ? ' couches' : ' couche');
      });
    });
    monument('', e.fermete);
    if (DUO) { monument('-g', e.fG); monument('-d', e.fD); }
    var pal = palierDe(e.fermete);

    /* ── 5 · LE SOUTIEN LOMBAIRE — il dépend de la fermeté ET de la largeur ;
       en duo, de la fermeté de SA poche. */
    majLombaire('lombaire', e.fermete, e);
    if (DUO) { majLombaire('lombaire-g', e.fG, e); majLombaire('lombaire-d', e.fD, e); }
    e = etat();   /* un « Avec » relâché change l'état : on relit avant la suite */

    /* ── 6 · LE VINYLE — indépendant du palier, il dépend de la largeur.
       « D’origine » est compris d'office ; BIOVYN porte son montant au moment du choix.
       🛑 DUO À UNE POCHE : le tarif n'a pas de prix BIOVYN (« uno » ou « dual », jamais
          « une poche d'un dual ») — la pastille est grisée AVEC SA RAISON, et un BIOVYN
          choisi avant se relâche vers le vinyle d'origine, l'inclus d'office : ce n'est pas
          un choix posé à la place du client, c'est l'état de base de la fiche, et la raison
          reste écrite sous la pastille. */
    var oBv = T.options.biovyn || {};
    var bvOk = true;   /* 05/10 : BIOVYN aussi pour une seule poche (63 €) */
    [].forEach.call(form.querySelectorAll('input[name="vinyle"]'), function (i) {
      var lab = i.closest('.ch'), pr = lab && lab.querySelector('.ch__p');
      if (i.value === 'standard') { if (pr) pr.textContent = 'compris'; return; }
      if (DUO) {
        i.disabled = !bvOk;
        if (lab) lab.classList.toggle('ch--non', !bvOk);
        if (!bvOk && i.checked) {
          i.checked = false;
          var std = form.querySelector('input[name="vinyle"][value="standard"]');
          if (std) std.checked = true;
        }
      }
      if (!pr) return;
      var pd = DUO ? prixBiovynDuo() : null;
      pr.textContent = DUO ? (e.poches === 1 ? '+' + eur(oBv.petit) + ' la poche'
          : e.poches === 2 ? (pd !== null ? '+' + eur(pd) + ' le lit' : 'sur demande')
          : '+' + eur(oBv.petit) + ' la poche ou +' + eur(pd) + ' le lit')
        : e.largeur ? '+' + eur(prixBiovyn(e.largeur))
        : (typeof oBv.petit === 'number' && typeof oBv.grand === 'number' ? '+' + eur(oBv.petit) + ' ou +' + eur(oBv.grand) : 'selon la largeur');
    });
    e = etat();   /* un BIOVYN relâché change l'état */
    /* 6 bis · les lignes « Sur demande — … » sous les options cochées */
    var sdR = surDemande(e);
    [['vinyle', sdR.indexOf('biovyn') >= 0]].forEach(function (x) {
      var el = form.querySelector('[data-sd="' + x[0] + '"]');
      if (el) el.hidden = !(ACHAT && x[1]);
    });

    /* ── 7 · LE RÉCAPITULATIF — une addition qu'on peut refaire à la main ──── */
    var c = calcul(e);
    var det;
    if (DUO) {
      var pdim = e.pocheLDite ? dim(e.pocheLDite, e.longueurDite) : null;
      var detPoche = function (p) {
        return GAMME + ' · ' + (pdim || 'taille à choisir') + ' · ' + (p && p.f ? p.f : 'fermeté à choisir');
      };
      var l0 = c.lignes[0], l1 = c.lignes[1];
      /* 🛑 05/10 (revue) · LE RÉCAPITULATIF REDIT LA TAILLE DU LIT. Il n'écrivait que
         « Poche de gauche · 80 × 200 cm » : la seule taille que le client a donnée — celle
         de son LIT — n'apparaissait plus au moment du bouton, et un client au lit de 160
         qui lit « 80 » doute. Première ligne, dès que le nombre de poches est choisi :
         « Votre lit · 2 poches de 80 × 200 cm · 160 × 200 cm ». */
      if (sorties.rLit) {
        var litVu = !!(e.largeurDite && e.longueurDite && e.poches && pdim);
        sorties.rLit.hidden = !litVu;
        if (litVu) {
          ecrire(sorties.rLitV, dim(e.largeurDite, e.longueurDite));
          ecrire(sorties.rLitD, e.poches === 2 ? '2 poches de ' + pdim : '1 poche de ' + pdim + ', ' + (e.poche ? 'celle de ' + e.poche : 'gauche ou droite'));
        }
      }
      if (!e.largeurDite) {
        ecrire(sorties.rBaseT, 'Matelas ' + GAMME);
        ecrire(sorties.rBaseD, enSur ? 'Donnez la cote de votre lit' : 'Choisissez la taille de votre lit');
      } else if (!e.poches) {
        ecrire(sorties.rBaseT, 'Matelas ' + GAMME);
        ecrire(sorties.rBaseD, 'Lit de ' + dim(e.largeurDite, e.longueurDite) + ' · une ou deux poches ?');
      } else {
        ecrire(sorties.rBaseT, e.poches === 2 ? 'Poche de gauche'
          : 'Votre poche' + (e.poche ? ' — ' + e.poche : ''));
        ecrire(sorties.rBaseD, detPoche(l0));
      }
      ecrire(sorties.rBaseP, l0 && l0.prix !== null ? eur(l0.prix) : '—', !(l0 && l0.prix !== null));
      if (sorties.rLigne2) {
        sorties.rLigne2.hidden = e.poches !== 2;
        ecrire(sorties.r2T, 'Poche de droite');
        ecrire(sorties.r2D, detPoche(l1));
        ecrire(sorties.r2P, l1 && l1.prix !== null ? eur(l1.prix) : '—', !(l1 && l1.prix !== null));
      }
      ligne(sorties.rLigneSpec, c.speciale !== null || sdR.indexOf('speciale') >= 0, c.speciale !== null ? c.speciale : 'sur demande');
      /* le soutien lombaire : UNE ligne d'addition, qui dit quelles poches le prennent */
      var avecL = c.lignes.filter(function (l) { return l.lombaire !== null; });
      ligne(sorties.rLigneLomb, c.lombaire !== null, c.lombaire);
      ecrire(sorties.rLombD, !avecL.length ? ''
        : e.poches === 2 ? (avecL.length === 2 ? 'les deux poches · 2 × ' + eur(avecL[0].lombaire)
          : 'poche de ' + avecL[0].cote + ' · ligne à part')
        : 'votre poche · ligne à part');
    } else {
      ecrire(sorties.rBaseT, 'Matelas ' + T.nom);
      if (!e.largeurDite) {
        det = enSur ? 'Donnez votre cote' : 'Choisissez la largeur du cadre';
      } else if (!e.longueurDite) {
        det = e.largeurDite + ' cm × — · ' + (pal ? pal.f : '—');
      } else {
        det = e.largeurDite + ' × ' + cm(e.longueurDite) + ' · ' + (pal ? pal.f : '—')
          + (e.speciale ? ' · facturé sur ' + e.largeur + ' × ' + cm(e.longueur) : '');
      }
      ecrire(sorties.rBaseD, det);
      ecrire(sorties.rBaseP, c.base === null ? '—' : eur(c.base), c.base === null);
      ligne(sorties.rLigneSpec, c.speciale !== null, c.speciale);
      ligne(sorties.rLigneLomb, c.lombaire !== null, c.lombaire);
    }
    /* le vinyle : « Vinyle d’origine · compris » tant que BIOVYN n'est pas choisi ; choisi,
       sa ligne le remplace et porte son montant DÈS QU'IL EST CONNU (la largeur en simple,
       les deux poches en duo) — un tiret d'attente avant, jamais un montant deviné. */
    var bvA = e.biovyn ? biovynPour(e) : null;
    if (sorties.rLigneVinO) sorties.rLigneVinO.hidden = !!e.biovyn;
    ligne(sorties.rLigneVin, !!e.biovyn, bvA ? bvA.prix : '—');
    if (sorties.rVinP) sorties.rVinP.classList.toggle('att', !!e.biovyn && !bvA);
    ecrire(sorties.rVinD, !e.biovyn ? '' : DUO && e.poches === 1 ? 'votre poche · ligne à part' : DUO ? 'les deux poches · ligne à part' : 'ligne à part');

    /* ── 8 · LE PRIX, DIT UNE FOIS ────────────────────────────────────────
       🛑 LA TETE OUVRE SUR LE PRIX D'ENTREE DE LA GAMME (`T.plancher`), atteignable,
          et devient EXACTE dès que la configuration est complète.
       En DUO, l'entrée est celle d'UNE poche (« la poche, à partir de ») — une seule
       poche en F0 la paie ; une fois le lit choisi, le plancher de CE lit. */
    var m = manques(e);
    var complet = !m.length && c.total !== null;
    /* 🛑 05/10 (revue) · « Les deux » coché, le minimum est celui de DEUX poches : la carte
       disait « dès 964 € », la barre et la tête « dès 482 € » — le prix d'une seule, sur le
       même écran. Le plancher se multiplie par le nombre de poches choisi (une tant qu'on
       n'a pas répondu : une seule poche en F0 le paie, il reste atteignable). */
    var nPoches = DUO && e.poches === 2 ? 2 : 1;
    if (DUO) {
      var plancherD = nPoches * (e.largeur ? prixBase(e.largeur, T.paliers[0].f) : T.plancher);
      if (c.total === null && sorties.prix) sorties.prix.innerHTML = DES + eur(plancherD); else ecrire(sorties.prix, eur(c.total));   /* 29/10 : « Dès » DEVANT, petit */
      ecrire(sorties.prixQ, c.total === null ? (nPoches === 2 ? 'les deux poches' : 'la poche')
        : (sdR.length ? 'hors supplément sur-mesure, à confirmer'
          : (e.poches === 2 ? '2 poches' : '1 poche') + ' · lit ' + dim(e.largeurDite, e.longueurDite)
            + (c.lombaire !== null && c.biovyn !== null ? ' · soutien lombaire et BIOVYN compris'
              : c.lombaire !== null ? ' · soutien lombaire compris'
              : c.biovyn !== null ? ' · vinyle BIOVYN compris' : '')));
    } else {
      if (c.total === null && sorties.prix) sorties.prix.innerHTML = DES + eur(T.plancher); else ecrire(sorties.prix, eur(c.total));
      ecrire(sorties.prixQ, c.total === null
        ? ''
        : (e.largeurDite && e.longueurDite
          ? e.largeurDite + ' × ' + cm(e.longueurDite) + ' · ' + (pal ? pal.f : '')
          : 'votre configuration'));
    }
    ecrire(sorties.rTotal, c.total === null ? '—' : eur(c.total), c.total === null);

    /* ── 9 · LE BOUTON — il dit ce qui se passe.
       🛑 SEULE UNE VARIANTE DONT L'IDENTIFIANT EST VÉRIFIÉ PORTE UN « AJOUTER ».
          On n'invente jamais une référence pour avoir un bouton. Ce qui ne passe
          pas par le panier porte « Demander », et le DIT au clic. */
    var b = sorties.bouton;
    if (b) {
      var lignesV = complet && !sdR.length ? variantePour(e, c) : null;
      b.disabled = !complet;
      if (garde) garde.hidden = complet;
      majConsignes(e);
      majVa(m);
      var phrase = '';
      if (!complet) {
        b.textContent = 'Ajouter au panier';
        b.removeAttribute('data-variante'); b.removeAttribute('data-sur-demande');
        /* le guide reste à jour tant qu'il est affiché : il nomme le manque suivant */
        if (aideMode === 'guide') aide(direManques(m), 'guide');
        else if (aideMode) aide('', null);
        /* ⚠️ toute autre phrase (« ajouté », « échec », « sur demande ») parlait d'un
           AUTRE état : `rendre` ne tourne qu'après un changement, elle se retire */
      } else if (sdR.length || (ACHAT && !lignesV)) {
        /* ⚠️ jamais un échec muet : le bouton reste VIVANT, et son clic dit pourquoi
           rien ne part au panier, avec un numéro et un lien */
        b.removeAttribute('data-variante');
        b.setAttribute('data-sur-demande', sdR.length ? sdR.join(' ') : 'introuvable');
        b.textContent = (DUO && e.poches === 2 ? 'Demander ces matelas' : 'Demander ce matelas')
          + (DUO ? '' : ' · ' + eur(c.total));
        phrase = sdR.length
          ? 'Sur demande : ' + liste(sdR.map(function (x) { return SD_DIT[x]; })) + ' — rien ne part au panier.'
          : 'À confirmer avec nous — rien ne part au panier.';
        if (aideMode) aide('', null);
      } else if (lignesV || !ACHAT) {
        b.removeAttribute('data-sur-demande');
        if (lignesV) b.setAttribute('data-variante', lignesV[0].id); else b.removeAttribute('data-variante');
        b.textContent = ACHAT ? 'Ajouter au panier · ' + eur(c.total) : 'Commander ce matelas · ' + eur(c.total);
        if (aideMode) aide('', null);
        /* la phrase dit ce qui part, ligne par ligne — le soutien lombaire compris */
        var supsV = lignesV ? lignesV.filter(function (l) { return l.sup; }) : [];
        var supsL = supsV.filter(function (l) { return l.quoi === 'lombaire'; });
        var supSpe = supsV.filter(function (l) { return l.quoi === 'speciale'; })[0] || null;
        var supB = supsV.filter(function (l) { return l.quoi === 'biovyn'; })[0] || null;
        var dirSup = !supsL.length ? ''
          : supsL.length === 2 ? ' — et le soutien lombaire des deux poches, sur deux lignes à part (+' + eur(c.lombaire) + ')'
          : (DUO && e.poches === 2 ? ' — et le soutien lombaire de la poche de ' + supsL[0].cote
            : DUO ? ', et son soutien lombaire' : 'Partiront au panier : le matelas et son soutien lombaire')
            + ', sur une ligne à part (+' + eur(c.lombaire) + ')';
        /* BIOVYN : sa propre ligne, dite à la suite (« sur une autre » quand le lombaire en a déjà une) */
        var dirBv = !supB ? ''
          : (supsL.length ? ' ; le vinyle BIOVYN' : DUO ? ' — et le vinyle BIOVYN' : 'Partiront au panier : le matelas et le vinyle BIOVYN')
            + (DUO ? (e.poches === 1 ? ' de cette poche' : ' des deux poches') : '') + ', sur ' + (supsL.length ? 'une autre ligne à part' : 'une ligne à part')
            + ' (+' + eur(supB.prix) + ')';
        dirBv += !supSpe ? '' : ' ; la dimension spéciale (facturée sur ' + dim(e.largeur, e.longueur) + '), sur une ligne à part (+' + eur(supSpe.prix) + ')';
        if (DUO && lignesV) {
          var pdx = dim(e.pocheL, e.longueur);
          /* la phrase part du LIT (« pour votre lit de 160 × 200 cm ») avant de dire les poches */
          var pourLit = ' au panier, pour votre lit de ' + dim(e.largeurDite, e.longueurDite) + ' : ';
          phrase = e.poches === 2
            ? 'Partiront' + pourLit + '2 matelas ' + GAMME + ' de ' + pdx + ' — gauche en ' + e.fG + ', droite en ' + e.fD + dirSup + dirBv + '.'
            : (supsV.length ? 'Partiront' : 'Partira') + pourLit + '1 matelas ' + GAMME + ' de ' + pdx + ', poche de ' + e.poche + ', en ' + e.fermete + dirSup + dirBv + '.';
        } else if (lignesV && supsV.length) phrase = dirSup + dirBv + '.';
      }
      if (sorties.phrase) { sorties.phrase.textContent = phrase; sorties.phrase.hidden = !phrase; }
      if (typeof majBarreBouton === 'function') majBarreBouton();
      if (sorties.barrePrix) sorties.barrePrix.textContent = c.total === null
        ? 'dès ' + eur(DUO ? nPoches * (e.largeur ? prixBase(e.largeur, T.paliers[0].f) : T.plancher) : plancherAu(e.fermete))
        : eur(c.total);
    }
  }

  /* De quelle bande de largeur releve la cote choisie ? (fiches simples)
     🛑 NE PAS L'APPELER `bandeDe` : une fonction de ce nom existe deja plus haut
        et rend un OBJET, pas un indice. Declarer la meme signature une seconde fois
        l'ecrase par hissage, et `prixBase` casse au chargement. Paye le 17/09. */
  function bandeIndex(l) {
    var b = (T && T.bandes) || [];
    for (var i = 0; i < b.length; i++) {
      if ((b[i].largeurs || []).indexOf(l) >= 0) return i;
    }
    return -1;
  }

  /* LES LIGNES DU PANIER — une par poche en duo, une en simple, ou `null`.
     🛑 LE PRIX AFFICHÉ ET LE PRIX FACTURÉ DOIVENT ÊTRE LE MÊME NOMBRE : une variante
        dont le prix diffère de celui de la page est refusée, le bouton retombe sur
        « Demander », qui ne débite rien.
     🛑 DUO — LA VARIANTE EST CELLE DE CE LIT, JAMAIS LA PREMIÈRE DE LA BANDE. La
        version d'avant prenait la première variante de la bande au bon prix : un lit
        de 150 recevait la poche de 70 (lit 140), au même prix — mesuré le 05/10. On
        exige désormais lit === largeur du lit, poche × 2 === lit, la fermeté dans
        `fs`, et le prix de la page. Sinon `null` : rien n'est approché. */
  function variantePour(e, c) {
    if (!ACHAT) {
      var v = T.verifiees || [];
      for (var i = 0; i < v.length; i++) {
        if (v[i].l === e.largeur && v[i].L === e.longueur && v[i].f === e.fermete
          && !e.lombaire && !e.biovyn && !e.speciale && c.total === v[i].prix) return [v[i]];
      }
      return null;
    }
    /* 05/10 : la dimension spéciale part au panier (supplément « Dimension spéciale matelas ») ; sans lui, rien */
    if (e.speciale && !(SUP.speciale && SUP.speciale.id)) return null;
    if (e.biovyn && !SUP.biovyn) return null;
    function supSp() {
      if (!e.speciale) return [];
      var s = SUP.speciale;
      if (!s || !s.id || s.prix !== T.options.speciale.prix || s.dispo === false) {
        try { console.warn('[mat8] dimension spéciale : aucun supplément à ' + T.options.speciale.prix + ' €'); } catch (x) { }
        return false;
      }
      return [{ id: s.id, prix: s.prix, f: null, cote: null, sup: true, quoi: 'speciale' }];
    }
    /* les lignes du soutien lombaire, APRÈS les matelas (comme les appoints des lits) :
       une par poche qui le prend, ou `false` si la boutique ne sert pas le bon supplément */
    function supsDe(liste, larg) {
      var out = [];
      for (var q = 0; q < liste.length; q++) {
        var po = liste[q];
        if (po.l !== 'oui' || !lombairePossible(po.f)) continue;
        var su = supLombaire(larg);
        if (!su) { try { console.warn('[mat8] soutien lombaire : aucun supplément à ' + prixLombaire(larg) + ' € pour ' + larg + ' cm'); } catch (x) { } return false; }
        out.push({ id: su.id, prix: su.prix, f: po.f, cote: po.cote, sup: true, quoi: 'lombaire' });
      }
      return out;
    }
    /* la ligne BIOVYN, la DERNIÈRE : une seule (le matelas en simple, le lit en duo), ou
       `false` si la boutique ne sert pas le supplément au prix affiché */
    function supBv() {
      if (!e.biovyn) return [];
      var b = biovynPour(e), s = supBiovyn(b);
      if (!s) { try { console.warn('[mat8] BIOVYN : aucun supplément ' + (b ? b.quel + ' à ' + b.prix + ' €' : 'pour cette configuration')); } catch (x) { } return false; }
      return [{ id: s.id, prix: s.prix, f: null, cote: null, sup: true, quoi: 'biovyn' }];
    }
    if (DUO) {
      if (!e.largeur || !e.longueur || !e.liste.length) return null;
      var out = [];
      for (var p = 0; p < e.liste.length; p++) {
        var po = e.liste[p];
        if (!po.f || !po.cote) return null;
        var prix = prixBase(e.largeur, po.f), hit = null;
        for (var k = 0; k < VAR.length; k++) {
          var x = VAR[k];
          if (x.lit !== e.largeur || x.poche * 2 !== e.largeur) continue;
          if ((x.fs || [x.f]).indexOf(po.f) < 0) continue;
          if (x.prix !== prix) continue;
          hit = x; break;
        }
        if (!hit) return null;
        out.push({ id: hit.id, prix: hit.prix, f: po.f, cote: po.cote });
      }
      var sd = supsDe(e.liste, e.pocheL);
      if (sd === false) return null;
      var bvl = supBv(), spl = supSp();
      return bvl === false || spl === false ? null : out.concat(sd, bvl, spl);
    }
    /* 🛑 LE PRIX NE DEPEND QUE DE LA BANDE ET DE LA FERMETE (tarif p. 37) : la cote
       exacte part en propriete de ligne. */
    var bi = bandeIndex(e.largeur);
    if (bi < 0 || !e.fermete || !e.longueur) return null;
    for (var j = 0; j < VAR.length; j++) {
      if (VAR[j].bande !== bi) continue;
      /* 🛑 UNE VARIANTE PEUT COUVRIR PLUSIEURS PALIERS (Hardside : « F3/F4/F5 ») */
      var fs = VAR[j].fs || [VAR[j].f];
      if (fs.indexOf(e.fermete) < 0) continue;
      /* ⚠️ le prix du MATELAS (`c.base`), pas le total : le soutien lombaire a sa ligne */
      if (typeof c.base === 'number' && c.base !== VAR[j].prix) continue;
      var ss = supsDe([{ l: e.lombaireV, f: e.fermete, cote: null }], e.largeur);
      if (ss === false) return null;
      var bs = supBv(), sps = supSp();
      return bs === false || sps === false ? null : [{ id: VAR[j].id, prix: VAR[j].prix, f: e.fermete }].concat(ss, bs, sps);
    }
    return null;
  }

  /* 🛑 CLIQUER UNE COTE DE LA LISTE RAMÈNE À LA LISTE. */
  var AGIR = ['largeur', 'longueur', 'fermete', 'fermete-g', 'fermete-d', 'poches', 'poche',
    'lombaire', 'lombaire-g', 'lombaire-d', 'vinyle'];
  form.addEventListener('change', function (ev) {
    var n = ev.target && ev.target.name;
    /* la pulsation de la consigne s'arrête au PREMIER choix : elle a fait son travail */
    if (AGIR.indexOf(n) >= 0) form.classList.add('a-agi');
    if ((n === 'largeur' || n === 'longueur') && lu('cote') === 'speciale') {
      var std = form.querySelector('input[name="cote"][value="standard"]');
      if (std) std.checked = true;
    }
    rendre();
    if (/^lombaire|^vinyle/.test(n || '')) voirSd(form.querySelector('[data-sd="' + n + '"]'));
  });
  /* `input` et pas `change` : le verdict doit suivre la frappe, sinon on croit
     que le champ n'est pas branché tant qu'on n'a pas quitté la case. */
  form.addEventListener('input', function (ev) {
    var n = ev.target && ev.target.name;
    if (n === 'surLargeur' || n === 'surLongueur') { form.classList.add('a-agi'); rendre(); }
  });
  rendre();
  /* 05/10 · LE RETOUR ARRIÈRE RESTITUE LES CHOIX (`state-preservation`) : le
     navigateur remet les radios cochés en revenant sur la page (cache de page ou
     restauration du formulaire) sans émettre `change` — la page affichait alors
     des choix faits sous des consignes « Choisissez… » et un bouton éteint. */
  addEventListener('pageshow', function () { rendre(); });

  /* ── L'AJOUT — ⚠️ hors boutique, `/cart/add.js` N'EXISTE PAS. Le bouton
     simule, montre l'appel qu'il ferait, et LE DIT. */
  function ajouter(btn) {
    if (!btn || btn.disabled) return;
    var e = etat();
    /* « sur demande » : rien ne part, et la page dit pourquoi — avec un numéro */
    if (btn.getAttribute('data-sur-demande')) { direSurDemande(surDemande(e)); return; }
    var c = calcul(e);
    var lignes = variantePour(e, c);
    var avant = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('data-attente', '1');
    btn.textContent = 'Ajout au panier…';

    /* 🛑 LE VRAI AJOUT. La cote exacte suit la ligne de commande en PROPRIETES,
       puisqu'elle ne change pas le prix. Sans elles, l'atelier recevrait une
       bande de largeur et ne saurait pas quoi fabriquer. */
    if (ACHAT && lignes && lignes.length) {
      /* 🛑 LE CADEAU DOIT ATTEINDRE L'ATELIER : il s'écrit sur la LIGNE de commande.
         Le COMPTE est lu sur la ligne de réassurance qui l'annonce (`data-m8-offert`) :
         un flacon PAR MATELAS (description de la boutique : « Un lit, c'est un
         matelas, donc un flacon […] si vous remplacez les deux matelas […] vous en
         recevez deux »). En duo, chaque poche est une ligne : un flacon par ligne.
         ⚠️ Si la page n'annonce pas le cadeau, on n'écrit rien. */
      var _off = document.querySelector('[data-m8-offert]');
      var offert = _off ? (parseInt(_off.getAttribute('data-m8-offert'), 10) || 1) + ' x Akva Long Life 380 ml' : null;
      var items = lignes.map(function (l) {
        var props = {};
        /* 🛑 LA LIGNE DU SOUTIEN LOMBAIRE DIT À QUEL MATELAS ELLE VA : sans ces précisions,
           l'atelier recevrait « Support lombaire (lit simple) » sans savoir quelle poche
           le porte — et en duo, deux lignes identiques. */
        /* la ligne BIOVYN dit le matelas qu'elle habille — en duo, le lit entier (les deux poches) */
        if (l.sup && l.quoi === 'speciale') {
          props['Pour'] = 'Matelas ' + GAMME + (DUO ? (e.poches === 1 ? ' — poche de ' + e.poche : ' — les deux poches') : '');
          props[DUO ? 'Taille du lit demandée' : 'Cote demandée'] = dim(e.largeurDite, e.longueurDite);
          props['Facturé sur'] = dim(e.largeur, e.longueur) + ' (taille standard supérieure)';
          return { id: Number(l.id), quantity: 1, properties: props };
        }
        if (l.sup && l.quoi === 'biovyn') {
          props['Pour'] = 'Matelas ' + GAMME + (DUO ? (e.poches === 1 ? ' — poche de ' + e.poche : ' — les deux poches') : '');
          if (DUO) {
            props['Taille du lit (cadre)'] = dim(e.largeurDite, e.longueurDite);
            props['Poches'] = e.poches === 1 ? 'une' : 'les deux';
            props['Taille de la poche'] = dim(e.pocheLDite || e.pocheL, e.longueurDite || e.longueur);   /* 05/10 : la cote DEMANDÉE (sur-mesure) */
          } else props['Taille du matelas'] = dim(e.largeur, e.longueur);
          return { id: Number(l.id), quantity: 1, properties: props };
        }
        if (l.sup) {
          props['Pour'] = 'Matelas ' + GAMME + (DUO ? ' — poche de ' + l.cote : '');
          if (DUO) {
            props['Taille du lit (cadre)'] = dim(e.largeurDite, e.longueurDite);
            props['Poche'] = l.cote;
            props['Taille de la poche'] = dim(e.pocheLDite || e.pocheL, e.longueurDite || e.longueur);   /* 05/10 : la cote DEMANDÉE (sur-mesure) */
            /* 🛑 05/10 (revue) · LE TITRE DU SUPPLÉMENT DIT « lit simple 90/100/120 » (donnée
               boutique, non modifiée ici). Pour la poche de 80 cm d'un lit de 160, c'est le bon
               supplément au bon prix — le format suit la largeur de la POCHE —, mais le client
               qui vient de déclarer un lit de 160 lit « lit simple » dans son panier. La ligne
               le lui explique. */
            props['Format'] = 'celui de la poche (' + cm(e.pocheL) + ' de large), pas celui du lit';
          } else props['Taille du matelas'] = dim(e.largeur, e.longueur);
          props['Stabilisation'] = l.f;
          return { id: Number(l.id), quantity: 1, properties: props };
        }
        if (DUO) {
          props['Taille du lit (cadre)'] = dim(e.largeurDite, e.longueurDite);
          props['Poche'] = l.cote;
          props['Taille de la poche'] = dim(e.pocheLDite || e.pocheL, e.longueurDite || e.longueur);   /* 05/10 : la cote DEMANDÉE (sur-mesure) */
          props['Stabilisation'] = l.f;
          if (e.speciale) props['Dimension spéciale'] = 'lit facturé sur ' + dim(e.largeur, e.longueur) + ' (ligne à part)';
          var lp = e.liste.filter(function (p) { return p.cote === l.cote; })[0];
          if (REQ.lombaire) props['Soutien lombaire'] = lp && lp.l === 'oui' ? 'Avec (ligne à part)' : 'Sans';
        } else {
          /* 🛑 05/10 · LA COTE À FABRIQUER EST LA COTE DEMANDÉE. En sur-mesure, `e.largeur` est la taille
             FACTURÉE (la standard supérieure) : l'envoyer comme « Largeur exacte » ferait fabriquer la mauvaise
             taille. Invisible tant que le sur-mesure ne partait pas au panier — il part depuis le 05/10. */
          var lD = e.largeurDite || e.largeur, LD = e.longueurDite || e.longueur;
          if (lD) props['Largeur exacte'] = lD + ' cm';
          if (LD) props['Longueur du couchage'] = LD + ' cm';
          if (e.speciale) props['Dimension spéciale'] = 'facturée sur ' + dim(e.largeur, e.longueur) + ' (ligne à part)';
          if (e.fermete) props['Stabilisation'] = e.fermete;
          if (REQ.lombaire) props['Soutien lombaire'] = e.lombaire ? 'Avec (ligne à part)' : 'Sans';
        }
        if (VIN_INCLUS || VIN_CHOIX) props['Vinyle'] = e.biovyn ? 'BIOVYN (ligne à part)' : 'D’origine (compris)';
        if (offert) props['Conditionneur offert'] = offert;
        return { id: Number(l.id), quantity: 1, properties: props };
      });
      /* 🛑 LA PASTILLE N'EXISTE PAS QUAND LE PANIER EST VIDE : on fait re-rendre la
         section par Shopify, et on la remplace. */
      var laePoser = function (id, html) {
        if (!html) return;
        var cible = document.getElementById(id);
        if (!cible) return;
        var boite = document.createElement('div');
        boite.innerHTML = html;
        var neuf = boite.querySelector('#' + id);
        cible.innerHTML = neuf ? neuf.innerHTML : boite.innerHTML;
      };
      var laeAnnoncer = function (rep) {
        /* 23/09 — le bandeau court de `laePanier` (assets/cart-notification.js),
           qui re-rend aussi la pastille ; la branche d'origine reste en repli. */
        if (window.laePanier) { window.laePanier.apresAjout(rep); return; }
        var sections = rep && rep.sections;
        if (!sections) return;
        var cle = rep.key || (rep.items && rep.items[0] && rep.items[0].key) || '';
        var cn = document.querySelector('cart-notification');
        if (cn && cle && typeof cn.renderContents === 'function') {
          try { cn.renderContents({ key: cle, sections: sections }); return; } catch (x) { }
        }
        laePoser('cart-icon-bubble', sections['cart-icon-bubble']);
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-notification-product,cart-notification-button,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function (rep) {
        laeAnnoncer(rep);
        btn.removeAttribute('data-attente');
        btn.textContent = 'Ajouté au panier';
        var nLo = lignes.filter(function (l) { return l.sup && l.quoi === 'lombaire'; }).length;
        var nBv = lignes.filter(function (l) { return l.quoi === 'biovyn'; }).length;
        var nSp = lignes.filter(function (l) { return l.quoi === 'speciale'; }).length;
        var nMat = lignes.length - nLo - nBv - nSp;
        var ex = [];
        if (nLo) ex.push(nLo > 1 ? nLo + ' soutiens lombaires' : (DUO ? 'le soutien lombaire' : 'son soutien lombaire'));
        if (nBv) ex.push('le vinyle BIOVYN');
        if (nSp) ex.push('la dimension spéciale');
        aide(DUO ? 'Ajouté au panier : ' + liste([nMat + ' matelas'].concat(ex)) + '. La taille de votre lit et le côté de chaque poche suivent la commande.'
          : 'Ajouté au panier' + (ex.length ? ' : ' + liste(['le matelas'].concat(ex)) : '') + '. Votre cote exacte suit la commande.', 'ok');
        setTimeout(function () { btn.textContent = avant; btn.disabled = false; }, 1600);
      }).catch(function (err) {
        /* ⚠️ Un echec doit se VOIR. */
        btn.removeAttribute('data-attente');
        btn.textContent = avant;
        btn.disabled = false;
        aide('L’ajout au panier a échoué (' + err.message +
               '). Rechargez la page, ou appelez-nous : 04 67 78 68 48.', 'err');
      });
      return;
    }

    setTimeout(function () {
      btn.removeAttribute('data-attente');
      btn.textContent = avant;
      btn.disabled = false;
      var id = lignes && lignes[0] ? lignes[0].id : null;
      aide(id
        ? 'Maquette — en boutique : POST /cart/add.js { id: ' + id + ', quantity: 1 }, puis relecture de /cart.js pour la pastille. Ici, rien n’est envoyé.'
        : 'Maquette — en boutique, cette cote ouvre une demande de fabrication (elle n’a pas de variante en stock). Ici, rien n’est envoyé.', 'ok');
    }, 620);
  }
  if (sorties.bouton) sorties.bouton.addEventListener('click', function () { ajouter(this); });
  /* 🛑 LA BARRE AJOUTE AU PANIER QUAND C'EST POSSIBLE. Elle délègue au bouton du
     panneau : deux chemins vers la MEME action, jamais deux actions. */
  var bB = document.querySelector('[data-out="barreBouton"]');
  if (bB) bB.addEventListener('click', function () {
    var principal = sorties.bouton;
    if (principal && !principal.disabled) {
      /* « sur demande » : la réponse vit sous le bouton du panneau — on y mène */
      if (principal.getAttribute('data-sur-demande')) {
        principal.scrollIntoView({ block: 'center', behavior: calme ? 'auto' : 'smooth' });
      }
      ajouter(principal); return;
    }
    /* 04/10 : la barre mène au PREMIER choix qui manque, pas au haut de la fiche */
    if (guider()) return;
    var cible = document.getElementById('configurer');
    if (cible) cible.scrollIntoView({ block: 'start' });
  });
  /* et son libelle suit l'etat, sinon elle ment sur ce qu'elle fait : il nomme le
     PREMIER choix manquant, dans l'ordre de la page (`manques`). */
  var BARRE_DIT = { largeur: 'Choisir la largeur', longueur: 'Choisir la longueur',
    fermete: 'Choisir la fermeté', 'fermete-g': 'Choisir la fermeté', 'fermete-d': 'Choisir la fermeté',
    sur: 'Donner les cotes', hors: 'Voir la solution', poches: 'Choisir les poches', poche: 'Choisir la poche',
    lombaire: 'Soutien lombaire', 'lombaire-g': 'Lombaire à gauche', 'lombaire-d': 'Lombaire à droite',
    vinyle: 'Choisir le vinyle' };
  function majBarreBouton() {
    if (!bB) return;
    var p = sorties.bouton;
    var pret = p && !p.disabled;
    var t = 'Composer';
    if (pret) t = p.textContent.replace(/ · .*/, '');
    else {
      var m = manques(etat());
      if (m.length && BARRE_DIT[m[0]]) t = BARRE_DIT[m[0]];
    }
    if (bB.textContent !== t) bB.textContent = t;
    bB.classList.remove('btn--nu');
  }
  majBarreBouton();

  /* ── LA BARRE DE TÉLÉPHONE — le prix ne quitte jamais l'écran. Elle se
     retire quand le panneau d'achat est visible : deux actions principales au
     même endroit annulent la décision. */
  var barre = sorties.barre, panneau = document.querySelector('.achat');
  if (barre && panneau && 'IntersectionObserver' in window) {
    /* 🛑 UN ELEMENT DE 0x0 N'INTERSECTE JAMAIS : on observe le bloc du PRIX. */
    var repere = document.querySelector('.fiche__prix') || document.querySelector('[data-repere-barre]');
    var voitPanneau = false, passeRepere = false;
    /* 🛑 04/10 (2e passe) — EN UNE COLONNE, LA BARRE EST LÀ DÈS LE CHARGEMENT.
       ⚠️ `matchMedia` vivant : une rotation change de régime sans recharger. */
    var uneColonne = window.matchMedia ? window.matchMedia('(max-width: 1080px)') : null;
    function majBarre() {
      var mobile = !!(uneColonne && uneColonne.matches);
      barre.classList.toggle('on', (passeRepere || mobile) && !voitPanneau);
    }
    if (uneColonne) {
      if (uneColonne.addEventListener) uneColonne.addEventListener('change', majBarre);
      else if (uneColonne.addListener) uneColonne.addListener(majBarre);
    }
    majBarre();
    new IntersectionObserver(function (es) {
      es.forEach(function (x) { voitPanneau = x.isIntersecting; }); majBarre();
    }, { threshold: 0.12 }).observe(panneau);
    if (repere) {
      new IntersectionObserver(function (es) {
        es.forEach(function (x) { passeRepere = !x.isIntersecting && x.boundingClientRect.top < 0; });
        majBarre();
      }, { threshold: 0 }).observe(repere);
    }
  }
})();

/* 🛑 L'INDICATEUR D'AMBIANCE S'EFFACE PENDANT LE RAIL. Il annonce le chapitre
   en haut a droite ; le panneau d'achat traverse ce coin quand la colonne
   collante se decroche, et les deux mono se superposent. Un `z-index` n'y peut
   rien — `position:sticky` cree toujours un contexte d'empilement, donc le rang
   du panneau reste enferme dans la colonne.
   Or la, l'indicateur est redondant : le panneau dit deja de quoi il s'agit. */
(function () {
  /* ⚠️ LA COLONNE A CHANGE DE NOM AVEC LA REFONTE. C'etait `.cfg__d`, le rail
     colle ; c'est maintenant `.fiche__a`, la colonne d'achat — qui occupe le
     meme coin haut-droit. Laisser l'ancien selecteur, c'est un fondu qui ne se
     declenche plus : le repere repassait sur le texte, et rien ne le disait.
     On garde l'ancien en repli pour ne rien casser ailleurs. */
  var col = document.querySelector('.fiche__a') || document.querySelector('.cfg__d');
  if (!col || !window.IntersectionObserver) return;
  /* ⚠️ ET SEULEMENT DANS LA BANDE OU IL GENE. Premiere version : on observait
     la colonne entiere, qui fait 1 200 px — elle croise la fenetre presque
     partout, et le repere restait efface sur TOUTE la page. On reduit donc la
     racine aux 120 premiers pixels : la colonne n'y entre qu'au moment ou elle
     passe derriere le repere, et nulle part ailleurs. */
  /* 🛑 ET LA BANDE DESCEND AVEC L'INDICATEUR. Portee dans le site, la fiche vit
     sous un en-tete COLLANT de 79 px : l'indicateur passe a `top:101` et la
     colonne d'achat commence 79 px plus bas — donc hors des 120 premiers pixels
     de la FENETRE. Mesure du 16/09 : le fondu ne se declenchait plus en ligne,
     et l'indicateur restait a 0,85 la ou la maquette l'efface.
     👉 On lit `--header-height`, que le theme expose. Dans la maquette autonome
        la variable n'existe pas, `parseFloat('')` rend NaN, le `|| 0` ramene a
        zero — le comportement local ne bouge pas d'un pixel. */
  var hautEntete = function () {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(v) || 0;
  };
  var bande = function () {
    return { rootMargin: '0px 0px -'
      + Math.max(0, window.innerHeight - 120 - hautEntete()) + 'px 0px' };
  };
  var obs;
  /* ⚠️ LA CLASSE VA SUR LA RACINE DU BLOC, PAS SUR `document.body`. Dans la
     maquette les deux sont le meme element ; portee dans le site, `body`
     appartient au THEME — y ecrire est un effet de bord hors du bloc, et la
     regle `.mat8--rail .ambiance` marche aussi bien depuis la racine. */
  var racine = col.closest('.mat8') || document.body;
  var poser = function () {
    if (obs) obs.disconnect();
    obs = new IntersectionObserver(function (e) {
      racine.classList.toggle('mat8--rail', e[0].isIntersecting);
    }, bande());
    obs.observe(col);
  };
  poser();
  window.addEventListener('resize', poser, { passive: true });
}());
